"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * AdminApi - axios parameter creator
 * @export
 */
var AdminApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary associate product display rule to catalog group product through the pair catalogProduct/catalogGroup
         * @param {string} catalogLogicId
         * @param {string} catalogProductLogicId
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} productDisplayRuleLogicIds list of comma separated product display rule logic ids to associate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssociateProductDisplayRules: function (catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminAssociateProductDisplayRules', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminAssociateProductDisplayRules', 'catalogProductLogicId', catalogProductLogicId);
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminAssociateProductDisplayRules', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'productDisplayRuleLogicIds' is not null or undefined
                    (0, common_1.assertParamExists)('adminAssociateProductDisplayRules', 'productDisplayRuleLogicIds', productDisplayRuleLogicIds);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}/catalog-products/{catalogProductLogicId}/product-display-rules"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)))
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (productDisplayRuleLogicIds) {
                        localVarQueryParameter['productDisplayRuleLogicIds'] = productDisplayRuleLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Bundling products
         * @param {string} productLogicId product logic id
         * @param {BundlingProductsRequest} [bundlingProductsRequest] Bundling products request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBundlingProducts: function (productLogicId, bundlingProductsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminBundlingProducts', 'productLogicId', productLogicId);
                    localVarPath = "/admin/products/{productLogicId}/relatedProducts"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bundlingProductsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create a product display
         * @param {ProductDisplayRuleDto} [productDisplayRuleDto] Creates a product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateProductDisplay: function (productDisplayRuleDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/product-display-rule";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productDisplayRuleDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary delete product display rule and its associations
         * @param {string} logicId logicId of the product display to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteProductDisplayRule: function (logicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDeleteProductDisplayRule', 'logicId', logicId);
                    localVarPath = "/admin/product-display-rule/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary dissociate product display rule from catalog group product through the pair catalogProduct/catalogGroup
         * @param {string} catalogLogicId
         * @param {string} catalogProductLogicId
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} productDisplayRuleLogicIds list of comma separated product display rule logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDissociateProductDisplayRules: function (catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDissociateProductDisplayRules', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDissociateProductDisplayRules', 'catalogProductLogicId', catalogProductLogicId);
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDissociateProductDisplayRules', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'productDisplayRuleLogicIds' is not null or undefined
                    (0, common_1.assertParamExists)('adminDissociateProductDisplayRules', 'productDisplayRuleLogicIds', productDisplayRuleLogicIds);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}/catalog-products/{catalogProductLogicId}/product-display-rules"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)))
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (productDisplayRuleLogicIds) {
                        localVarQueryParameter['productDisplayRuleLogicIds'] = productDisplayRuleLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary search a product display
         * @param {string} logicId search a product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductDisplayRule: function (logicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminGetProductDisplayRule', 'logicId', logicId);
                    localVarPath = "/admin/product-display-rule/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Relatable products
         * @param {string} productLogicId
         * @param {RelationTypeEnum} relationType
         * @param {Array<string>} [productAttributeLogicIds] list of comma separated product attribute logic ids
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRelatableProducts: function (productLogicId, relationType, productAttributeLogicIds, sort, page, size, includeMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminRelatableProducts', 'productLogicId', productLogicId);
                    // verify required parameter 'relationType' is not null or undefined
                    (0, common_1.assertParamExists)('adminRelatableProducts', 'relationType', relationType);
                    localVarPath = "/admin/products/{productLogicId}/relatedProducts"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (productAttributeLogicIds) {
                        localVarQueryParameter['productAttributeLogicIds'] = productAttributeLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (relationType !== undefined) {
                        localVarQueryParameter['relationType'] = relationType;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Unbundling products
         * @param {string} productLogicId
         * @param {Array<string>} productLogicIds list of comma separated product logic ids to unbund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUnbundlingProducts: function (productLogicId, productLogicIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminUnbundlingProducts', 'productLogicId', productLogicId);
                    // verify required parameter 'productLogicIds' is not null or undefined
                    (0, common_1.assertParamExists)('adminUnbundlingProducts', 'productLogicIds', productLogicIds);
                    localVarPath = "/admin/products/{productLogicId}/relatedProducts"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (productLogicIds) {
                        localVarQueryParameter['productLogicIds'] = productLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary update productDisplay
         * @param {string} logicId logicId of product display to update
         * @param {ProductDisplayRuleDto} [productDisplayRuleDto] Update product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductDisplay: function (logicId, productDisplayRuleDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminUpdateProductDisplay', 'logicId', logicId);
                    localVarPath = "/admin/product-display-rule/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productDisplayRuleDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Associates products and catalog-group - liquidation and availability left unset
         * @param {string} catalogGroupLogicId
         * @param {AssociateCatalogGroupProductsRequest} [associateCatalogGroupProductsRequest] Create catalog-group-products associations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateCatalogGroupProducts: function (catalogGroupLogicId, associateCatalogGroupProductsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('associateCatalogGroupProducts', 'catalogGroupLogicId', catalogGroupLogicId);
                    localVarPath = "/admin/catalogGroups/{catalogGroupLogicId}/catalogProducts"
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(associateCatalogGroupProductsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Associates products and catalog - creates product fee initialized to 0
         * @param {string} catalogLogicId
         * @param {AssociateCatalogProductsRequest} [associateCatalogProductsRequest] Create catalog-products associations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateCatalogProducts: function (catalogLogicId, associateCatalogProductsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('associateCatalogProducts', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/products"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(associateCatalogProductsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Associate attribute to a product
         * @param {string} productLogicId product logic id
         * @param {AttributeProductsRequest} [attributeProductsRequest] product attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateProductAttribute: function (productLogicId, attributeProductsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('associateProductAttribute', 'productLogicId', productLogicId);
                    localVarPath = "/admin/products/{productLogicId}/attributes"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attributeProductsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Associates a purchase parameter to a product
         * @param {string} productLogicId product logic id
         * @param {AssociatePurchaseParamRequest} [associatePurchaseParamRequest] Associate purchase param request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associatePurchaseParam: function (productLogicId, associatePurchaseParamRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('associatePurchaseParam', 'productLogicId', productLogicId);
                    localVarPath = "/admin/products/{productLogicId}/purchase-parameters"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(associatePurchaseParamRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Changes a partner status
         * @param {string} partnerLogicId partner logic id
         * @param {ChangePartnerStatusRequest} [changePartnerStatusRequest] Changes a partner status (ACTIVE or DELETED)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePartnerStatus: function (partnerLogicId, changePartnerStatusRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'partnerLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('changePartnerStatus', 'partnerLogicId', partnerLogicId);
                    localVarPath = "/admin/partners/{partnerLogicId}/status"
                        .replace("{".concat("partnerLogicId", "}"), encodeURIComponent(String(partnerLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changePartnerStatusRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Changes a product status
         * @param {string} productLogicId product logic id
         * @param {ChangeProductStatusRequest} [changeProductStatusRequest] Changes a product status (ACTIVE or DELETED)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeProductStatus: function (productLogicId, changeProductStatusRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('changeProductStatus', 'productLogicId', productLogicId);
                    localVarPath = "/admin/products/{productLogicId}/status"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeProductStatusRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a Attribute
         * @param {CreateAttributeRequest} [createAttributeRequest] Create attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttribute: function (createAttributeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/attributes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createAttributeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a brand
         * @param {CreateBrandRequest} [createBrandRequest] Create brand request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: function (createBrandRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/brands";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createBrandRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a brand category
         * @param {CreateBrandCategoryRequest} [createBrandCategoryRequest] Create brand category request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandCategory: function (createBrandCategoryRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/brand-categories";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createBrandCategoryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a Liquidation
         * @param {LiquidationRequest} [liquidationRequest] Create Liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLiquidation: function (liquidationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/liquidations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(liquidationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a partner
         * @param {CreatePartnerRequest} [createPartnerRequest] Create partner request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner: function (createPartnerRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/partners";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPartnerRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a product
         * @param {CreateProductRequest} [createProductRequest] Create product request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (createProductRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/products";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createProductRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a purchase param
         * @param {CreatePurchaseParamRequest} [createPurchaseParamRequest] Create purchaseParam request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseParam: function (createPurchaseParamRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/purchase-param";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPurchaseParamRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a supplier
         * @param {CreateSupplierRequest} [createSupplierRequest] Create supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplier: function (createSupplierRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/suppliers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSupplierRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a Attribute if there are no products associated
         * @param {string} attributeLogicId Attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttribute: function (attributeLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'attributeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteAttribute', 'attributeLogicId', attributeLogicId);
                    localVarPath = "/admin/attributes/{attributeLogicId}"
                        .replace("{".concat("attributeLogicId", "}"), encodeURIComponent(String(attributeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a Attribute if there are no products associated
         * @param {string} attributeValueLogicId Attribute Value logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributeValue: function (attributeValueLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'attributeValueLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteAttributeValue', 'attributeValueLogicId', attributeValueLogicId);
                    localVarPath = "/admin/attribute-values/{attributeValueLogicId}"
                        .replace("{".concat("attributeValueLogicId", "}"), encodeURIComponent(String(attributeValueLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a brand if there are no products associated
         * @param {string} brandLogicId brand logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand: function (brandLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteBrand', 'brandLogicId', brandLogicId);
                    localVarPath = "/admin/brands/{brandLogicId}"
                        .replace("{".concat("brandLogicId", "}"), encodeURIComponent(String(brandLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary delete a category for idCategory
         * @param {string} logicId category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryById: function (logicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCategoryById', 'logicId', logicId);
                    localVarPath = "/admin/users/categories/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete the attribute from a specific flow
         * @summary Delete the attribute from a specific flow
         * @param {string} attributeLogicId
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterAttributeFlow: function (attributeLogicId, clusterFlowLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'attributeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteClusterAttributeFlow', 'attributeLogicId', attributeLogicId);
                    // verify required parameter 'clusterFlowLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteClusterAttributeFlow', 'clusterFlowLogicId', clusterFlowLogicId);
                    localVarPath = "/admin/users/attributes/attribute/{attributeLogicId}/cluster-flow/{clusterFlowLogicId}"
                        .replace("{".concat("attributeLogicId", "}"), encodeURIComponent(String(attributeLogicId)))
                        .replace("{".concat("clusterFlowLogicId", "}"), encodeURIComponent(String(clusterFlowLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete an existing cluster:  The Backoffice modify an existing cluster
         * @param {string} logicId cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterById: function (logicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteClusterById', 'logicId', logicId);
                    localVarPath = "/admin/users/clusters/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete the cluster flow and the relation of attributes between the flow
         * @summary Delete the cluster flow and the relation of attributes between the flow
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterFlow: function (clusterFlowLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'clusterFlowLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteClusterFlow', 'clusterFlowLogicId', clusterFlowLogicId);
                    localVarPath = "/admin/users/flows/cluster-flow/{clusterFlowLogicId}"
                        .replace("{".concat("clusterFlowLogicId", "}"), encodeURIComponent(String(clusterFlowLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a sector if there are no products associated
         * @param {string} liquidationLogicId liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLiquidation: function (liquidationLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'liquidationLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteLiquidation', 'liquidationLogicId', liquidationLogicId);
                    localVarPath = "/admin/liquidations/{liquidationLogicId}"
                        .replace("{".concat("liquidationLogicId", "}"), encodeURIComponent(String(liquidationLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete attribute to a product
         * @param {string} productLogicId product logic id
         * @param {string} productAttributeLogicId product attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductAttribute: function (productLogicId, productAttributeLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteProductAttribute', 'productLogicId', productLogicId);
                    // verify required parameter 'productAttributeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteProductAttribute', 'productAttributeLogicId', productAttributeLogicId);
                    localVarPath = "/admin/products/{productLogicId}/attributes/{productAttributeLogicId}"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)))
                        .replace("{".concat("productAttributeLogicId", "}"), encodeURIComponent(String(productAttributeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a purchase param if there are no products associated
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseParam: function (purchaseParamLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'purchaseParamLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deletePurchaseParam', 'purchaseParamLogicId', purchaseParamLogicId);
                    localVarPath = "/admin/purchase-param/{purchaseParamLogicId}"
                        .replace("{".concat("purchaseParamLogicId", "}"), encodeURIComponent(String(purchaseParamLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete the single status
         * @summary Delete the single status
         * @param {string} statusLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus: function (statusLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'statusLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteStatus', 'statusLogicId', statusLogicId);
                    localVarPath = "/admin/users/status/{statusLogicId}"
                        .replace("{".concat("statusLogicId", "}"), encodeURIComponent(String(statusLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete the single status route for a status
         * @summary Delete the single status route for a status
         * @param {string} statusLogicId
         * @param {string} statusRouteLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatusRouteForStatus: function (statusLogicId, statusRouteLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'statusLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteStatusRouteForStatus', 'statusLogicId', statusLogicId);
                    // verify required parameter 'statusRouteLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteStatusRouteForStatus', 'statusRouteLogicId', statusRouteLogicId);
                    localVarPath = "/admin/users/status/{statusLogicId}/status-route/{statusRouteLogicId}"
                        .replace("{".concat("statusLogicId", "}"), encodeURIComponent(String(statusLogicId)))
                        .replace("{".concat("statusRouteLogicId", "}"), encodeURIComponent(String(statusRouteLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a supplier if there are no products associated
         * @param {string} supplierLogicId supplier logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplier: function (supplierLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'supplierLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSupplier', 'supplierLogicId', supplierLogicId);
                    localVarPath = "/admin/suppliers/{supplierLogicId}"
                        .replace("{".concat("supplierLogicId", "}"), encodeURIComponent(String(supplierLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary delete a wallet configuration for idWalletConfig
         * @param {string} idLogic id configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWalletConfById: function (idLogic, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'idLogic' is not null or undefined
                    (0, common_1.assertParamExists)('deleteWalletConfById', 'idLogic', idLogic);
                    localVarPath = "/admin/wallets/configurations/{idLogic}"
                        .replace("{".concat("idLogic", "}"), encodeURIComponent(String(idLogic)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Disassociates a purchase parameter from a product
         * @param {string} productLogicId product logic id
         * @param {string} purchaseParameterLogicId purchaseParameter logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disassociatePurchaseParam: function (productLogicId, purchaseParameterLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('disassociatePurchaseParam', 'productLogicId', productLogicId);
                    // verify required parameter 'purchaseParameterLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('disassociatePurchaseParam', 'purchaseParameterLogicId', purchaseParameterLogicId);
                    localVarPath = "/admin/products/{productLogicId}/purchase-parameters/{purchaseParameterLogicId}"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)))
                        .replace("{".concat("purchaseParameterLogicId", "}"), encodeURIComponent(String(purchaseParameterLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Dissociates products and catalog group
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} catalogProductLogicIds list of comma separated catalog product logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dissociateCatalogGroupProducts: function (catalogGroupLogicId, catalogProductLogicIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('dissociateCatalogGroupProducts', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'catalogProductLogicIds' is not null or undefined
                    (0, common_1.assertParamExists)('dissociateCatalogGroupProducts', 'catalogProductLogicIds', catalogProductLogicIds);
                    localVarPath = "/admin/catalogGroups/{catalogGroupLogicId}/catalogProducts"
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (catalogProductLogicIds) {
                        localVarQueryParameter['catalogProductLogicIds'] = catalogProductLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Dissociates products and catalog
         * @param {string} catalogLogicId
         * @param {Array<string>} productLogicIds list of comma separated product logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dissociateCatalogProducts: function (catalogLogicId, productLogicIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('dissociateCatalogProducts', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'productLogicIds' is not null or undefined
                    (0, common_1.assertParamExists)('dissociateCatalogProducts', 'productLogicIds', productLogicIds);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/products"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (productLogicIds) {
                        localVarQueryParameter['productLogicIds'] = productLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the list of all attributes available on JNext Platform, the list of attributes configured for a project, the list of attribute related with the cluster, and the list of cms related to the attribute
         * @summary Get all the attributes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAttributes: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/users/attributes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the list of all categories:  The Backoffice returns the list of all categories
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCategories: function (page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/users/categories";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the list of all clusters for specific category logic id:  The Backoffice returns the list of all clusters for specific category logic id
         * @param {string} logicIdCategory category logic id
         * @param {string} [page] Current page number
         * @param {string} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClustersByCategoryLogicId: function (logicIdCategory, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicIdCategory' is not null or undefined
                    (0, common_1.assertParamExists)('getAllClustersByCategoryLogicId', 'logicIdCategory', logicIdCategory);
                    localVarPath = "/admin/users/categories/{logicIdCategory}/clusters"
                        .replace("{".concat("logicIdCategory", "}"), encodeURIComponent(String(logicIdCategory)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get clusters configurations for wallets
         * @summary get clusters configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClustersWalletsConf: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/wallets/configurations/clusters";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get currencies configurations for wallets
         * @summary get currencies configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCurrenciesWalletsConf: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/wallets/configurations/currencies";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get reset-strategy configurations for wallets
         * @summary get reset-strategy configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResetStrategyWalletsConf: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/wallets/configurations/reset-strategy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the list of all wallets configurations:  The Backoffice returns the list of all wallets configurations
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {boolean} [includeGenerated] if true, include Fl generated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWalletConf: function (page, size, includeGenerated, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/wallets/configurations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeGenerated !== undefined) {
                        localVarQueryParameter['includeGenerated'] = includeGenerated;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get wallets-type configurations for wallets
         * @summary get wallets-type configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWalletsTypeWalletsConf: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/wallets/configurations/wallets-type";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a Attribute
         * @param {string} attributeLogicId Attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttribute: function (attributeLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'attributeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getAttribute', 'attributeLogicId', attributeLogicId);
                    localVarPath = "/admin/attributes/{attributeLogicId}"
                        .replace("{".concat("attributeLogicId", "}"), encodeURIComponent(String(attributeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves all attributes
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes: function (page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/attributes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the list of default attribute avalaible on jNext platform
         * @summary Get the list of default attribute avalaible on jNext platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesDefault: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/users/attributes/default";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a brand
         * @param {string} brandLogicId brand logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand: function (brandLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getBrand', 'brandLogicId', brandLogicId);
                    localVarPath = "/admin/brands/{brandLogicId}"
                        .replace("{".concat("brandLogicId", "}"), encodeURIComponent(String(brandLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged brand categories filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] brand category name (LIKE mode)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCategories: function (page, size, includeMetadata, sort, name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/brand-categories";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a brand category
         * @param {string} brandCategoryLogicId brand category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCategory: function (brandCategoryLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandCategoryLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getBrandCategory', 'brandCategoryLogicId', brandCategoryLogicId);
                    localVarPath = "/admin/brand-categories/{brandCategoryLogicId}"
                        .replace("{".concat("brandCategoryLogicId", "}"), encodeURIComponent(String(brandCategoryLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged brands filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] brand name (LIKE mode)
         * @param {string} [partnerLogicId] filter by exact partner logic id
         * @param {string} [brandCategoryLogicId] filter by exact brand category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands: function (page, size, includeMetadata, sort, name, partnerLogicId, brandCategoryLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/brands";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (partnerLogicId !== undefined) {
                        localVarQueryParameter['partnerLogicId'] = partnerLogicId;
                    }
                    if (brandCategoryLogicId !== undefined) {
                        localVarQueryParameter['brandCategoryLogicId'] = brandCategoryLogicId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a category for idCategory
         * @param {string} logicId category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById: function (logicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCategoryById', 'logicId', logicId);
                    localVarPath = "/admin/users/categories/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all the attributes related to a cluster and clusterFlow
         * @summary Get all the attributes related to a cluster and clusterFlow
         * @param {string} clusterLogicId
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterAttributesFlow: function (clusterLogicId, clusterFlowLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'clusterLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getClusterAttributesFlow', 'clusterLogicId', clusterLogicId);
                    // verify required parameter 'clusterFlowLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getClusterAttributesFlow', 'clusterFlowLogicId', clusterFlowLogicId);
                    localVarPath = "/admin/users/attributes/cluster/{clusterLogicId}/cluster-flow/{clusterFlowLogicId}"
                        .replace("{".concat("clusterLogicId", "}"), encodeURIComponent(String(clusterLogicId)))
                        .replace("{".concat("clusterFlowLogicId", "}"), encodeURIComponent(String(clusterFlowLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a cluster for clusterLogicId
         * @param {string} logicId cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterById: function (logicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('getClusterById', 'logicId', logicId);
                    localVarPath = "/admin/users/clusters/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the list of all flows related to a specific cluster or all the cluster of the project
         * @param {string} [clusterLogicId] cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterFlows: function (clusterLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/users/flows";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (clusterLogicId !== undefined) {
                        localVarQueryParameter['clusterLogicId'] = clusterLogicId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get all the flows type availabe on JNext Platform
         * @summary get all flows type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowTypeList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/flows";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a liquidation
         * @param {string} liquidationLogicId Liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiquidation: function (liquidationLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'liquidationLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getLiquidation', 'liquidationLogicId', liquidationLogicId);
                    localVarPath = "/admin/liquidations/{liquidationLogicId}"
                        .replace("{".concat("liquidationLogicId", "}"), encodeURIComponent(String(liquidationLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged liquidations filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [type] type of the liquidation param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiquidations: function (page, size, includeMetadata, sort, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/liquidations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a partner
         * @param {string} partnerLogicId partner logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartner: function (partnerLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'partnerLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getPartner', 'partnerLogicId', partnerLogicId);
                    localVarPath = "/admin/partners/{partnerLogicId}"
                        .replace("{".concat("partnerLogicId", "}"), encodeURIComponent(String(partnerLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged partners filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] partner name (LIKE mode)
         * @param {string} [status] partner status
         * @param {string} [catalogLogicId] catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartners: function (page, size, includeMetadata, sort, name, status, catalogLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/partners";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (catalogLogicId !== undefined) {
                        localVarQueryParameter['catalogLogicId'] = catalogLogicId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a product
         * @param {string} productLogicId product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (productLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getProduct', 'productLogicId', productLogicId);
                    localVarPath = "/admin/products/{productLogicId}"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves purchase parameters associated to a product
         * @param {string} productLogicId product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPurchaseParams: function (productLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductPurchaseParams', 'productLogicId', productLogicId);
                    localVarPath = "/admin/products/{productLogicId}/purchase-parameters"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged products filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [sku] product sku (LIKE mode)
         * @param {string} [logicId] product logicId
         * @param {string} [externalId] product externalId (LIKE mode)
         * @param {string} [name] product name (LIKE mode)
         * @param {string} [partnerLogicId] product partnerLogicId
         * @param {string} [brandLogicId] product brandLogicId
         * @param {string} [supplierLogicId] product supplierLogicId
         * @param {string} [status] product status
         * @param {string} [relationType] product relationType
         * @param {string} [productType] product productType
         * @param {number} [minPurchasePrice] product minPurchasePrice
         * @param {number} [maxPurchasePrice] product maxPurchasePrice
         * @param {string} [excludeInCatalogLogicId] Get only available products not already in the catalogue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (page, size, includeMetadata, sort, sku, logicId, externalId, name, partnerLogicId, brandLogicId, supplierLogicId, status, relationType, productType, minPurchasePrice, maxPurchasePrice, excludeInCatalogLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/products";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (sku !== undefined) {
                        localVarQueryParameter['sku'] = sku;
                    }
                    if (logicId !== undefined) {
                        localVarQueryParameter['logicId'] = logicId;
                    }
                    if (externalId !== undefined) {
                        localVarQueryParameter['externalId'] = externalId;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (partnerLogicId !== undefined) {
                        localVarQueryParameter['partnerLogicId'] = partnerLogicId;
                    }
                    if (brandLogicId !== undefined) {
                        localVarQueryParameter['brandLogicId'] = brandLogicId;
                    }
                    if (supplierLogicId !== undefined) {
                        localVarQueryParameter['supplierLogicId'] = supplierLogicId;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (relationType !== undefined) {
                        localVarQueryParameter['relationType'] = relationType;
                    }
                    if (productType !== undefined) {
                        localVarQueryParameter['productType'] = productType;
                    }
                    if (minPurchasePrice !== undefined) {
                        localVarQueryParameter['minPurchasePrice'] = minPurchasePrice;
                    }
                    if (maxPurchasePrice !== undefined) {
                        localVarQueryParameter['maxPurchasePrice'] = maxPurchasePrice;
                    }
                    if (excludeInCatalogLogicId !== undefined) {
                        localVarQueryParameter['excludeInCatalogLogicId'] = excludeInCatalogLogicId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a purchase param
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParam: function (purchaseParamLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'purchaseParamLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getPurchaseParam', 'purchaseParamLogicId', purchaseParamLogicId);
                    localVarPath = "/admin/purchase-param/{purchaseParamLogicId}"
                        .replace("{".concat("purchaseParamLogicId", "}"), encodeURIComponent(String(purchaseParamLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged purchase params filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [type] type of the purhcase param
         * @param {string} [hurlId] hurlId of the purhcase param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParams: function (page, size, includeMetadata, sort, type, hurlId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/purchase-param";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (hurlId !== undefined) {
                        localVarQueryParameter['hurlId'] = hurlId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the single status
         * @summary Get the single status
         * @param {string} statusLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: function (statusLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'statusLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getStatus', 'statusLogicId', statusLogicId);
                    localVarPath = "/admin/users/status/{statusLogicId}"
                        .replace("{".concat("statusLogicId", "}"), encodeURIComponent(String(statusLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the list of status for a project
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusList: function (jakProject, jakTenant, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'jakProject' is not null or undefined
                    (0, common_1.assertParamExists)('getStatusList', 'jakProject', jakProject);
                    // verify required parameter 'jakTenant' is not null or undefined
                    (0, common_1.assertParamExists)('getStatusList', 'jakTenant', jakTenant);
                    localVarPath = "/admin/users/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (jakProject !== undefined && jakProject !== null) {
                        localVarHeaderParameter['jak-project'] = String(jakProject);
                    }
                    if (jakTenant !== undefined && jakTenant !== null) {
                        localVarHeaderParameter['jak-tenant'] = String(jakTenant);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the list of status routes for a status
         * @param {string} statusLogicId
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusRouteForStatusList: function (statusLogicId, jakProject, jakTenant, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'statusLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getStatusRouteForStatusList', 'statusLogicId', statusLogicId);
                    // verify required parameter 'jakProject' is not null or undefined
                    (0, common_1.assertParamExists)('getStatusRouteForStatusList', 'jakProject', jakProject);
                    // verify required parameter 'jakTenant' is not null or undefined
                    (0, common_1.assertParamExists)('getStatusRouteForStatusList', 'jakTenant', jakTenant);
                    localVarPath = "/admin/users/status-routes/status/{statusLogicId}"
                        .replace("{".concat("statusLogicId", "}"), encodeURIComponent(String(statusLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (jakProject !== undefined && jakProject !== null) {
                        localVarHeaderParameter['jak-project'] = String(jakProject);
                    }
                    if (jakTenant !== undefined && jakTenant !== null) {
                        localVarHeaderParameter['jak-tenant'] = String(jakTenant);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a supplier
         * @param {string} supplierLogicId supplier logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier: function (supplierLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'supplierLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getSupplier', 'supplierLogicId', supplierLogicId);
                    localVarPath = "/admin/suppliers/{supplierLogicId}"
                        .replace("{".concat("supplierLogicId", "}"), encodeURIComponent(String(supplierLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged suppliers filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] supplier name (LIKE mode)
         * @param {string} [partnerLogicId] filter by exact partner logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliers: function (page, size, includeMetadata, sort, name, partnerLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/suppliers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (partnerLogicId !== undefined) {
                        localVarQueryParameter['partnerLogicId'] = partnerLogicId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a wallet configuration:  The Backoffice return a wallet configuration by specific id
         * @param {string} idLogic id configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletConfById: function (idLogic, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'idLogic' is not null or undefined
                    (0, common_1.assertParamExists)('getWalletConfById', 'idLogic', idLogic);
                    localVarPath = "/admin/wallets/configurations/{idLogic}"
                        .replace("{".concat("idLogic", "}"), encodeURIComponent(String(idLogic)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post a new category:  The Backoffice create a new category
         * @param {CreateClusterCategoryRequest} createClusterCategoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCategory: function (createClusterCategoryRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createClusterCategoryRequest' is not null or undefined
                    (0, common_1.assertParamExists)('insertCategory', 'createClusterCategoryRequest', createClusterCategoryRequest);
                    localVarPath = "/admin/users/categories";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createClusterCategoryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post a new cluster for a specific category:  The Backoffice create a new cluster
         * @param {string} logicIdCategory category logic id
         * @param {CreateClusterRequest} createClusterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCluster: function (logicIdCategory, createClusterRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicIdCategory' is not null or undefined
                    (0, common_1.assertParamExists)('insertCluster', 'logicIdCategory', logicIdCategory);
                    // verify required parameter 'createClusterRequest' is not null or undefined
                    (0, common_1.assertParamExists)('insertCluster', 'createClusterRequest', createClusterRequest);
                    localVarPath = "/admin/users/categories/{logicIdCategory}/clusters"
                        .replace("{".concat("logicIdCategory", "}"), encodeURIComponent(String(logicIdCategory)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createClusterRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Insert Status routes for a status
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {StatusesRouteListForStatusDto} statusesRouteListForStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertStatusRouteForStatus: function (jakProject, jakTenant, statusesRouteListForStatusDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'jakProject' is not null or undefined
                    (0, common_1.assertParamExists)('insertStatusRouteForStatus', 'jakProject', jakProject);
                    // verify required parameter 'jakTenant' is not null or undefined
                    (0, common_1.assertParamExists)('insertStatusRouteForStatus', 'jakTenant', jakTenant);
                    // verify required parameter 'statusesRouteListForStatusDto' is not null or undefined
                    (0, common_1.assertParamExists)('insertStatusRouteForStatus', 'statusesRouteListForStatusDto', statusesRouteListForStatusDto);
                    localVarPath = "/admin/users/status-routes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (jakProject !== undefined && jakProject !== null) {
                        localVarHeaderParameter['jak-project'] = String(jakProject);
                    }
                    if (jakTenant !== undefined && jakTenant !== null) {
                        localVarHeaderParameter['jak-tenant'] = String(jakTenant);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(statusesRouteListForStatusDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post a new wallet configuration:  The Backoffice create a new wallet configuration
         * @param {WalletConfigurationRequest} walletConfigurationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWalletConf: function (walletConfigurationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'walletConfigurationRequest' is not null or undefined
                    (0, common_1.assertParamExists)('insertWalletConf', 'walletConfigurationRequest', walletConfigurationRequest);
                    localVarPath = "/admin/wallets/configurations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(walletConfigurationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary modify status for a specific idCategory
         * @param {string} logicId category logic id
         * @param {UpdateClusterCategoryStatusRequestChildDto} updateClusterCategoryStatusRequestChildDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStatusCategoryById: function (logicId, updateClusterCategoryStatusRequestChildDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('patchStatusCategoryById', 'logicId', logicId);
                    // verify required parameter 'updateClusterCategoryStatusRequestChildDto' is not null or undefined
                    (0, common_1.assertParamExists)('patchStatusCategoryById', 'updateClusterCategoryStatusRequestChildDto', updateClusterCategoryStatusRequestChildDto);
                    localVarPath = "/admin/users/categories/{logicId}/status"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateClusterCategoryStatusRequestChildDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the list of all attributes available on JNext Platform, the list of attributes configured for a project, the list of attribute related with the cluster, and the list of cms related to the attribute
         * @summary Get all the attributes
         * @param {string} redemptionsRestartWorkflowId redemptions restart workflow id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryRedemptionsRestartWorkflow: function (redemptionsRestartWorkflowId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'redemptionsRestartWorkflowId' is not null or undefined
                    (0, common_1.assertParamExists)('queryRedemptionsRestartWorkflow', 'redemptionsRestartWorkflowId', redemptionsRestartWorkflowId);
                    localVarPath = "/admin/redemptions/restart/{redemptionsRestartWorkflowId}/query"
                        .replace("{".concat("redemptionsRestartWorkflowId", "}"), encodeURIComponent(String(redemptionsRestartWorkflowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Redeem a reward
         * @param {string} rewardLogicId
         * @param {RedeemRewardRequest} redeemRewardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemReward: function (rewardLogicId, redeemRewardRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'rewardLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('redeemReward', 'rewardLogicId', rewardLogicId);
                    // verify required parameter 'redeemRewardRequest' is not null or undefined
                    (0, common_1.assertParamExists)('redeemReward', 'redeemRewardRequest', redeemRewardRequest);
                    localVarPath = "/admin/rewards/{rewardLogicId}/redeem"
                        .replace("{".concat("rewardLogicId", "}"), encodeURIComponent(String(rewardLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(redeemRewardRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Restart a set of redemptions
         * @param {string} jakProject
         * @param {RestartRedemptionsRequest} restartRedemptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartRedemptionWorkflows: function (jakProject, restartRedemptionsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'jakProject' is not null or undefined
                    (0, common_1.assertParamExists)('restartRedemptionWorkflows', 'jakProject', jakProject);
                    // verify required parameter 'restartRedemptionsRequest' is not null or undefined
                    (0, common_1.assertParamExists)('restartRedemptionWorkflows', 'restartRedemptionsRequest', restartRedemptionsRequest);
                    localVarPath = "/admin/redemptions/restart";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (jakProject !== undefined && jakProject !== null) {
                        localVarHeaderParameter['jak-project'] = String(jakProject);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(restartRedemptionsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [walletLogicId]
         * @param {Array<string>} [initiativeLogicId]
         * @param {string} [transactionDateStart]
         * @param {string} [transactionDateEnd]
         * @param {number} [minAmount]
         * @param {number} [maxAmount]
         * @param {Array<string>} [statusExternalIds]
         * @param {Array<string>} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransaction: function (page, size, includeMetadata, walletLogicId, initiativeLogicId, transactionDateStart, transactionDateEnd, minAmount, maxAmount, statusExternalIds, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'page' is not null or undefined
                    (0, common_1.assertParamExists)('searchTransaction', 'page', page);
                    // verify required parameter 'size' is not null or undefined
                    (0, common_1.assertParamExists)('searchTransaction', 'size', size);
                    localVarPath = "/admin/transaction";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (walletLogicId) {
                        localVarQueryParameter['walletLogicId'] = walletLogicId;
                    }
                    if (initiativeLogicId) {
                        localVarQueryParameter['initiativeLogicId'] = initiativeLogicId;
                    }
                    if (transactionDateStart !== undefined) {
                        localVarQueryParameter['transactionDateStart'] = (transactionDateStart instanceof Date) ?
                            transactionDateStart.toISOString() :
                            transactionDateStart;
                    }
                    if (transactionDateEnd !== undefined) {
                        localVarQueryParameter['transactionDateEnd'] = (transactionDateEnd instanceof Date) ?
                            transactionDateEnd.toISOString() :
                            transactionDateEnd;
                    }
                    if (minAmount !== undefined) {
                        localVarQueryParameter['minAmount'] = minAmount;
                    }
                    if (maxAmount !== undefined) {
                        localVarQueryParameter['maxAmount'] = maxAmount;
                    }
                    if (statusExternalIds) {
                        localVarQueryParameter['statusExternalIds'] = statusExternalIds;
                    }
                    if (userId) {
                        localVarQueryParameter['userId'] = userId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a Attribute
         * @param {string} attributeLogicId Attribute logic id
         * @param {UpdateAttributeRequest} [updateAttributeRequest] Update Attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttribute: function (attributeLogicId, updateAttributeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'attributeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateAttribute', 'attributeLogicId', attributeLogicId);
                    localVarPath = "/admin/attributes/{attributeLogicId}"
                        .replace("{".concat("attributeLogicId", "}"), encodeURIComponent(String(attributeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAttributeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a brand
         * @param {string} brandLogicId brand logic id
         * @param {UpdateBrandRequest} [updateBrandRequest] Update brand request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand: function (brandLogicId, updateBrandRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateBrand', 'brandLogicId', brandLogicId);
                    localVarPath = "/admin/brands/{brandLogicId}"
                        .replace("{".concat("brandLogicId", "}"), encodeURIComponent(String(brandLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateBrandRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a brand category
         * @param {string} brandCategoryLogicId brand category logic id
         * @param {UpdateBrandCategoryRequest} [updateBrandCategoryRequest] Update brand category request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandCategory: function (brandCategoryLogicId, updateBrandCategoryRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandCategoryLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateBrandCategory', 'brandCategoryLogicId', brandCategoryLogicId);
                    localVarPath = "/admin/brand-categories/{brandCategoryLogicId}"
                        .replace("{".concat("brandCategoryLogicId", "}"), encodeURIComponent(String(brandCategoryLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateBrandCategoryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update catalogGroupOProduct\'s properties
         * @param {string} catalogGroupLogicId
         * @param {string} catalogProductLogicId
         * @param {UpdateCatalogGroupProductRequest} [updateCatalogGroupProductRequest] Update catalog-group-product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroupProduct: function (catalogGroupLogicId, catalogProductLogicId, updateCatalogGroupProductRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCatalogGroupProduct', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCatalogGroupProduct', 'catalogProductLogicId', catalogProductLogicId);
                    localVarPath = "/admin/catalogGroups/{catalogGroupLogicId}/catalogProducts/{catalogProductLogicId}/catalogGroupProducts"
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCatalogGroupProductRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Modify a category for idCategory
         * @param {string} logicId category logic id
         * @param {UpdateClusterCategoryRequest} updateClusterCategoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryById: function (logicId, updateClusterCategoryRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCategoryById', 'logicId', logicId);
                    // verify required parameter 'updateClusterCategoryRequest' is not null or undefined
                    (0, common_1.assertParamExists)('updateCategoryById', 'updateClusterCategoryRequest', updateClusterCategoryRequest);
                    localVarPath = "/admin/users/categories/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateClusterCategoryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update an existing cluster:  The Backoffice modify an existing cluster
         * @param {string} logicId cluster logic id
         * @param {UpdateClusterRequest} updateClusterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClusterById: function (logicId, updateClusterRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateClusterById', 'logicId', logicId);
                    // verify required parameter 'updateClusterRequest' is not null or undefined
                    (0, common_1.assertParamExists)('updateClusterById', 'updateClusterRequest', updateClusterRequest);
                    localVarPath = "/admin/users/clusters/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateClusterRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a liquidation
         * @param {string} liquidationLogicId liquidation logic id
         * @param {LiquidationDto} [liquidationDto] Update liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLiquidation: function (liquidationLogicId, liquidationDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'liquidationLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateLiquidation', 'liquidationLogicId', liquidationLogicId);
                    localVarPath = "/admin/liquidations/{liquidationLogicId}"
                        .replace("{".concat("liquidationLogicId", "}"), encodeURIComponent(String(liquidationLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(liquidationDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a partner
         * @param {string} partnerLogicId partner logic id
         * @param {UpdatePartnerRequest} [updatePartnerRequest] Update partner request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner: function (partnerLogicId, updatePartnerRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'partnerLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updatePartner', 'partnerLogicId', partnerLogicId);
                    localVarPath = "/admin/partners/{partnerLogicId}"
                        .replace("{".concat("partnerLogicId", "}"), encodeURIComponent(String(partnerLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePartnerRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a product
         * @param {string} productLogicId product logic id
         * @param {UpdateProductRequest} [updateProductRequest] Update product request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (productLogicId, updateProductRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateProduct', 'productLogicId', productLogicId);
                    localVarPath = "/admin/products/{productLogicId}"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateProductRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a Product Fee
         * @param {string} catalogProductLogicId
         * @param {UpdateProductFeesRequest} [updateProductFeesRequest] Update product fees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductFees: function (catalogProductLogicId, updateProductFeesRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateProductFees', 'catalogProductLogicId', catalogProductLogicId);
                    localVarPath = "/admin/catalogProducts/{catalogProductLogicId}/fees"
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateProductFeesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update product purchase parameter
         * @param {string} productLogicId product logic id
         * @param {UpdateProductPurchaseParamRequest} [updateProductPurchaseParamRequest] Associate purchase param request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductPurchaseParameter: function (productLogicId, updateProductPurchaseParamRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateProductPurchaseParameter', 'productLogicId', productLogicId);
                    localVarPath = "/admin/products/{productLogicId}/purchase-parameters"
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateProductPurchaseParamRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a purchase param
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {UpdatePurchaseParamRequest} [updatePurchaseParamRequest] Update purchaseParam request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseParam: function (purchaseParamLogicId, updatePurchaseParamRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'purchaseParamLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updatePurchaseParam', 'purchaseParamLogicId', purchaseParamLogicId);
                    localVarPath = "/admin/purchase-param/{purchaseParamLogicId}"
                        .replace("{".concat("purchaseParamLogicId", "}"), encodeURIComponent(String(purchaseParamLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePurchaseParamRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a supplier
         * @param {string} supplierLogicId supplier logic id
         * @param {UpdateSupplierRequest} [updateSupplierRequest] Update supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplier: function (supplierLogicId, updateSupplierRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'supplierLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSupplier', 'supplierLogicId', supplierLogicId);
                    localVarPath = "/admin/suppliers/{supplierLogicId}"
                        .replace("{".concat("supplierLogicId", "}"), encodeURIComponent(String(supplierLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSupplierRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Modify a wallet configuration for idWalletConfiguration
         * @param {string} idLogic id configuration
         * @param {WalletConfigurationRequest} walletConfigurationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWalletConfById: function (idLogic, walletConfigurationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'idLogic' is not null or undefined
                    (0, common_1.assertParamExists)('updateWalletConfById', 'idLogic', idLogic);
                    // verify required parameter 'walletConfigurationRequest' is not null or undefined
                    (0, common_1.assertParamExists)('updateWalletConfById', 'walletConfigurationRequest', walletConfigurationRequest);
                    localVarPath = "/admin/wallets/configurations/{idLogic}"
                        .replace("{".concat("idLogic", "}"), encodeURIComponent(String(idLogic)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(walletConfigurationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Upsert Attribute in a specific flow
         * @param {string} jakProject
         * @param {UpsertAttributeCfgRequestDto} upsertAttributeCfgRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertAttribute: function (jakProject, upsertAttributeCfgRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'jakProject' is not null or undefined
                    (0, common_1.assertParamExists)('upsertAttribute', 'jakProject', jakProject);
                    // verify required parameter 'upsertAttributeCfgRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('upsertAttribute', 'upsertAttributeCfgRequestDto', upsertAttributeCfgRequestDto);
                    localVarPath = "/admin/users/attributes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (jakProject !== undefined && jakProject !== null) {
                        localVarHeaderParameter['jak-project'] = String(jakProject);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsertAttributeCfgRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post a new flow for a specific cluster:  The Backoffice create or update a new cluster flow
         * @param {string} clusterLogicId cluster logic id
         * @param {string} jakProject
         * @param {UpsertClusterFlowRequestDto} upsertClusterFlowRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertClusterFlow: function (clusterLogicId, jakProject, upsertClusterFlowRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'clusterLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('upsertClusterFlow', 'clusterLogicId', clusterLogicId);
                    // verify required parameter 'jakProject' is not null or undefined
                    (0, common_1.assertParamExists)('upsertClusterFlow', 'jakProject', jakProject);
                    // verify required parameter 'upsertClusterFlowRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('upsertClusterFlow', 'upsertClusterFlowRequestDto', upsertClusterFlowRequestDto);
                    localVarPath = "/admin/users/flows";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (clusterLogicId !== undefined) {
                        localVarQueryParameter['clusterLogicId'] = clusterLogicId;
                    }
                    if (jakProject !== undefined && jakProject !== null) {
                        localVarHeaderParameter['jak-project'] = String(jakProject);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsertClusterFlowRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Upsert Status with StatusRoute
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {StatusesListForProjectDto} statusesListForProjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStatus: function (jakProject, jakTenant, statusesListForProjectDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'jakProject' is not null or undefined
                    (0, common_1.assertParamExists)('upsertStatus', 'jakProject', jakProject);
                    // verify required parameter 'jakTenant' is not null or undefined
                    (0, common_1.assertParamExists)('upsertStatus', 'jakTenant', jakTenant);
                    // verify required parameter 'statusesListForProjectDto' is not null or undefined
                    (0, common_1.assertParamExists)('upsertStatus', 'statusesListForProjectDto', statusesListForProjectDto);
                    localVarPath = "/admin/users/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (jakProject !== undefined && jakProject !== null) {
                        localVarHeaderParameter['jak-project'] = String(jakProject);
                    }
                    if (jakTenant !== undefined && jakTenant !== null) {
                        localVarHeaderParameter['jak-tenant'] = String(jakTenant);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(statusesListForProjectDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
var AdminApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary associate product display rule to catalog group product through the pair catalogProduct/catalogGroup
         * @param {string} catalogLogicId
         * @param {string} catalogProductLogicId
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} productDisplayRuleLogicIds list of comma separated product display rule logic ids to associate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssociateProductDisplayRules: function (catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminAssociateProductDisplayRules(catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Bundling products
         * @param {string} productLogicId product logic id
         * @param {BundlingProductsRequest} [bundlingProductsRequest] Bundling products request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBundlingProducts: function (productLogicId, bundlingProductsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminBundlingProducts(productLogicId, bundlingProductsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a product display
         * @param {ProductDisplayRuleDto} [productDisplayRuleDto] Creates a product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateProductDisplay: function (productDisplayRuleDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateProductDisplay(productDisplayRuleDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete product display rule and its associations
         * @param {string} logicId logicId of the product display to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteProductDisplayRule: function (logicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteProductDisplayRule(logicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary dissociate product display rule from catalog group product through the pair catalogProduct/catalogGroup
         * @param {string} catalogLogicId
         * @param {string} catalogProductLogicId
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} productDisplayRuleLogicIds list of comma separated product display rule logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDissociateProductDisplayRules: function (catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDissociateProductDisplayRules(catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary search a product display
         * @param {string} logicId search a product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductDisplayRule: function (logicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetProductDisplayRule(logicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Relatable products
         * @param {string} productLogicId
         * @param {RelationTypeEnum} relationType
         * @param {Array<string>} [productAttributeLogicIds] list of comma separated product attribute logic ids
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRelatableProducts: function (productLogicId, relationType, productAttributeLogicIds, sort, page, size, includeMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminRelatableProducts(productLogicId, relationType, productAttributeLogicIds, sort, page, size, includeMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unbundling products
         * @param {string} productLogicId
         * @param {Array<string>} productLogicIds list of comma separated product logic ids to unbund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUnbundlingProducts: function (productLogicId, productLogicIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUnbundlingProducts(productLogicId, productLogicIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary update productDisplay
         * @param {string} logicId logicId of product display to update
         * @param {ProductDisplayRuleDto} [productDisplayRuleDto] Update product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductDisplay: function (logicId, productDisplayRuleDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateProductDisplay(logicId, productDisplayRuleDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Associates products and catalog-group - liquidation and availability left unset
         * @param {string} catalogGroupLogicId
         * @param {AssociateCatalogGroupProductsRequest} [associateCatalogGroupProductsRequest] Create catalog-group-products associations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateCatalogGroupProducts: function (catalogGroupLogicId, associateCatalogGroupProductsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.associateCatalogGroupProducts(catalogGroupLogicId, associateCatalogGroupProductsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Associates products and catalog - creates product fee initialized to 0
         * @param {string} catalogLogicId
         * @param {AssociateCatalogProductsRequest} [associateCatalogProductsRequest] Create catalog-products associations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateCatalogProducts: function (catalogLogicId, associateCatalogProductsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.associateCatalogProducts(catalogLogicId, associateCatalogProductsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Associate attribute to a product
         * @param {string} productLogicId product logic id
         * @param {AttributeProductsRequest} [attributeProductsRequest] product attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateProductAttribute: function (productLogicId, attributeProductsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.associateProductAttribute(productLogicId, attributeProductsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Associates a purchase parameter to a product
         * @param {string} productLogicId product logic id
         * @param {AssociatePurchaseParamRequest} [associatePurchaseParamRequest] Associate purchase param request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associatePurchaseParam: function (productLogicId, associatePurchaseParamRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.associatePurchaseParam(productLogicId, associatePurchaseParamRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Changes a partner status
         * @param {string} partnerLogicId partner logic id
         * @param {ChangePartnerStatusRequest} [changePartnerStatusRequest] Changes a partner status (ACTIVE or DELETED)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePartnerStatus: function (partnerLogicId, changePartnerStatusRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.changePartnerStatus(partnerLogicId, changePartnerStatusRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Changes a product status
         * @param {string} productLogicId product logic id
         * @param {ChangeProductStatusRequest} [changeProductStatusRequest] Changes a product status (ACTIVE or DELETED)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeProductStatus: function (productLogicId, changeProductStatusRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.changeProductStatus(productLogicId, changeProductStatusRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a Attribute
         * @param {CreateAttributeRequest} [createAttributeRequest] Create attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttribute: function (createAttributeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAttribute(createAttributeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a brand
         * @param {CreateBrandRequest} [createBrandRequest] Create brand request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: function (createBrandRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBrand(createBrandRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a brand category
         * @param {CreateBrandCategoryRequest} [createBrandCategoryRequest] Create brand category request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandCategory: function (createBrandCategoryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBrandCategory(createBrandCategoryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a Liquidation
         * @param {LiquidationRequest} [liquidationRequest] Create Liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLiquidation: function (liquidationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLiquidation(liquidationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a partner
         * @param {CreatePartnerRequest} [createPartnerRequest] Create partner request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner: function (createPartnerRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPartner(createPartnerRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a product
         * @param {CreateProductRequest} [createProductRequest] Create product request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (createProductRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProduct(createProductRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a purchase param
         * @param {CreatePurchaseParamRequest} [createPurchaseParamRequest] Create purchaseParam request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseParam: function (createPurchaseParamRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPurchaseParam(createPurchaseParamRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a supplier
         * @param {CreateSupplierRequest} [createSupplierRequest] Create supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplier: function (createSupplierRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplier(createSupplierRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a Attribute if there are no products associated
         * @param {string} attributeLogicId Attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttribute: function (attributeLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAttribute(attributeLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a Attribute if there are no products associated
         * @param {string} attributeValueLogicId Attribute Value logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributeValue: function (attributeValueLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAttributeValue(attributeValueLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a brand if there are no products associated
         * @param {string} brandLogicId brand logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand: function (brandLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteBrand(brandLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete a category for idCategory
         * @param {string} logicId category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryById: function (logicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCategoryById(logicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete the attribute from a specific flow
         * @summary Delete the attribute from a specific flow
         * @param {string} attributeLogicId
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterAttributeFlow: function (attributeLogicId, clusterFlowLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteClusterAttributeFlow(attributeLogicId, clusterFlowLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an existing cluster:  The Backoffice modify an existing cluster
         * @param {string} logicId cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterById: function (logicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteClusterById(logicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete the cluster flow and the relation of attributes between the flow
         * @summary Delete the cluster flow and the relation of attributes between the flow
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterFlow: function (clusterFlowLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteClusterFlow(clusterFlowLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a sector if there are no products associated
         * @param {string} liquidationLogicId liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLiquidation: function (liquidationLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLiquidation(liquidationLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete attribute to a product
         * @param {string} productLogicId product logic id
         * @param {string} productAttributeLogicId product attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductAttribute: function (productLogicId, productAttributeLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProductAttribute(productLogicId, productAttributeLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a purchase param if there are no products associated
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseParam: function (purchaseParamLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePurchaseParam(purchaseParamLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * delete the single status
         * @summary Delete the single status
         * @param {string} statusLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus: function (statusLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteStatus(statusLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * delete the single status route for a status
         * @summary Delete the single status route for a status
         * @param {string} statusLogicId
         * @param {string} statusRouteLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatusRouteForStatus: function (statusLogicId, statusRouteLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteStatusRouteForStatus(statusLogicId, statusRouteLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a supplier if there are no products associated
         * @param {string} supplierLogicId supplier logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplier: function (supplierLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplier(supplierLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete a wallet configuration for idWalletConfig
         * @param {string} idLogic id configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWalletConfById: function (idLogic, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteWalletConfById(idLogic, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Disassociates a purchase parameter from a product
         * @param {string} productLogicId product logic id
         * @param {string} purchaseParameterLogicId purchaseParameter logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disassociatePurchaseParam: function (productLogicId, purchaseParameterLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.disassociatePurchaseParam(productLogicId, purchaseParameterLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Dissociates products and catalog group
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} catalogProductLogicIds list of comma separated catalog product logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dissociateCatalogGroupProducts: function (catalogGroupLogicId, catalogProductLogicIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dissociateCatalogGroupProducts(catalogGroupLogicId, catalogProductLogicIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Dissociates products and catalog
         * @param {string} catalogLogicId
         * @param {Array<string>} productLogicIds list of comma separated product logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dissociateCatalogProducts: function (catalogLogicId, productLogicIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dissociateCatalogProducts(catalogLogicId, productLogicIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get the list of all attributes available on JNext Platform, the list of attributes configured for a project, the list of attribute related with the cluster, and the list of cms related to the attribute
         * @summary Get all the attributes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAttributes: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllAttributes(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of all categories:  The Backoffice returns the list of all categories
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCategories: function (page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllCategories(page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of all clusters for specific category logic id:  The Backoffice returns the list of all clusters for specific category logic id
         * @param {string} logicIdCategory category logic id
         * @param {string} [page] Current page number
         * @param {string} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClustersByCategoryLogicId: function (logicIdCategory, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllClustersByCategoryLogicId(logicIdCategory, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get clusters configurations for wallets
         * @summary get clusters configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClustersWalletsConf: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllClustersWalletsConf(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get currencies configurations for wallets
         * @summary get currencies configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCurrenciesWalletsConf: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllCurrenciesWalletsConf(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get reset-strategy configurations for wallets
         * @summary get reset-strategy configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResetStrategyWalletsConf: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllResetStrategyWalletsConf(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of all wallets configurations:  The Backoffice returns the list of all wallets configurations
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {boolean} [includeGenerated] if true, include Fl generated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWalletConf: function (page, size, includeGenerated, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllWalletConf(page, size, includeGenerated, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get wallets-type configurations for wallets
         * @summary get wallets-type configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWalletsTypeWalletsConf: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllWalletsTypeWalletsConf(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a Attribute
         * @param {string} attributeLogicId Attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttribute: function (attributeLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAttribute(attributeLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves all attributes
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes: function (page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAttributes(page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get the list of default attribute avalaible on jNext platform
         * @summary Get the list of default attribute avalaible on jNext platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesDefault: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAttributesDefault(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a brand
         * @param {string} brandLogicId brand logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand: function (brandLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrand(brandLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged brand categories filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] brand category name (LIKE mode)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCategories: function (page, size, includeMetadata, sort, name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandCategories(page, size, includeMetadata, sort, name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a brand category
         * @param {string} brandCategoryLogicId brand category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCategory: function (brandCategoryLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandCategory(brandCategoryLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged brands filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] brand name (LIKE mode)
         * @param {string} [partnerLogicId] filter by exact partner logic id
         * @param {string} [brandCategoryLogicId] filter by exact brand category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands: function (page, size, includeMetadata, sort, name, partnerLogicId, brandCategoryLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrands(page, size, includeMetadata, sort, name, partnerLogicId, brandCategoryLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a category for idCategory
         * @param {string} logicId category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById: function (logicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCategoryById(logicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all the attributes related to a cluster and clusterFlow
         * @summary Get all the attributes related to a cluster and clusterFlow
         * @param {string} clusterLogicId
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterAttributesFlow: function (clusterLogicId, clusterFlowLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getClusterAttributesFlow(clusterLogicId, clusterFlowLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a cluster for clusterLogicId
         * @param {string} logicId cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterById: function (logicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getClusterById(logicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of all flows related to a specific cluster or all the cluster of the project
         * @param {string} [clusterLogicId] cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterFlows: function (clusterLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getClusterFlows(clusterLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get all the flows type availabe on JNext Platform
         * @summary get all flows type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowTypeList: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFlowTypeList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a liquidation
         * @param {string} liquidationLogicId Liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiquidation: function (liquidationLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLiquidation(liquidationLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged liquidations filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [type] type of the liquidation param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiquidations: function (page, size, includeMetadata, sort, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLiquidations(page, size, includeMetadata, sort, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a partner
         * @param {string} partnerLogicId partner logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartner: function (partnerLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPartner(partnerLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged partners filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] partner name (LIKE mode)
         * @param {string} [status] partner status
         * @param {string} [catalogLogicId] catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartners: function (page, size, includeMetadata, sort, name, status, catalogLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPartners(page, size, includeMetadata, sort, name, status, catalogLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a product
         * @param {string} productLogicId product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (productLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProduct(productLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves purchase parameters associated to a product
         * @param {string} productLogicId product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPurchaseParams: function (productLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductPurchaseParams(productLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged products filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [sku] product sku (LIKE mode)
         * @param {string} [logicId] product logicId
         * @param {string} [externalId] product externalId (LIKE mode)
         * @param {string} [name] product name (LIKE mode)
         * @param {string} [partnerLogicId] product partnerLogicId
         * @param {string} [brandLogicId] product brandLogicId
         * @param {string} [supplierLogicId] product supplierLogicId
         * @param {string} [status] product status
         * @param {string} [relationType] product relationType
         * @param {string} [productType] product productType
         * @param {number} [minPurchasePrice] product minPurchasePrice
         * @param {number} [maxPurchasePrice] product maxPurchasePrice
         * @param {string} [excludeInCatalogLogicId] Get only available products not already in the catalogue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (page, size, includeMetadata, sort, sku, logicId, externalId, name, partnerLogicId, brandLogicId, supplierLogicId, status, relationType, productType, minPurchasePrice, maxPurchasePrice, excludeInCatalogLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProducts(page, size, includeMetadata, sort, sku, logicId, externalId, name, partnerLogicId, brandLogicId, supplierLogicId, status, relationType, productType, minPurchasePrice, maxPurchasePrice, excludeInCatalogLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a purchase param
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParam: function (purchaseParamLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPurchaseParam(purchaseParamLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged purchase params filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [type] type of the purhcase param
         * @param {string} [hurlId] hurlId of the purhcase param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParams: function (page, size, includeMetadata, sort, type, hurlId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPurchaseParams(page, size, includeMetadata, sort, type, hurlId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get the single status
         * @summary Get the single status
         * @param {string} statusLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: function (statusLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStatus(statusLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of status for a project
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusList: function (jakProject, jakTenant, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStatusList(jakProject, jakTenant, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of status routes for a status
         * @param {string} statusLogicId
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusRouteForStatusList: function (statusLogicId, jakProject, jakTenant, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStatusRouteForStatusList(statusLogicId, jakProject, jakTenant, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a supplier
         * @param {string} supplierLogicId supplier logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier: function (supplierLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplier(supplierLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged suppliers filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] supplier name (LIKE mode)
         * @param {string} [partnerLogicId] filter by exact partner logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliers: function (page, size, includeMetadata, sort, name, partnerLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSuppliers(page, size, includeMetadata, sort, name, partnerLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a wallet configuration:  The Backoffice return a wallet configuration by specific id
         * @param {string} idLogic id configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletConfById: function (idLogic, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getWalletConfById(idLogic, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post a new category:  The Backoffice create a new category
         * @param {CreateClusterCategoryRequest} createClusterCategoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCategory: function (createClusterCategoryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.insertCategory(createClusterCategoryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post a new cluster for a specific category:  The Backoffice create a new cluster
         * @param {string} logicIdCategory category logic id
         * @param {CreateClusterRequest} createClusterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCluster: function (logicIdCategory, createClusterRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.insertCluster(logicIdCategory, createClusterRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Insert Status routes for a status
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {StatusesRouteListForStatusDto} statusesRouteListForStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertStatusRouteForStatus: function (jakProject, jakTenant, statusesRouteListForStatusDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.insertStatusRouteForStatus(jakProject, jakTenant, statusesRouteListForStatusDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post a new wallet configuration:  The Backoffice create a new wallet configuration
         * @param {WalletConfigurationRequest} walletConfigurationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWalletConf: function (walletConfigurationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.insertWalletConf(walletConfigurationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary modify status for a specific idCategory
         * @param {string} logicId category logic id
         * @param {UpdateClusterCategoryStatusRequestChildDto} updateClusterCategoryStatusRequestChildDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStatusCategoryById: function (logicId, updateClusterCategoryStatusRequestChildDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchStatusCategoryById(logicId, updateClusterCategoryStatusRequestChildDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get the list of all attributes available on JNext Platform, the list of attributes configured for a project, the list of attribute related with the cluster, and the list of cms related to the attribute
         * @summary Get all the attributes
         * @param {string} redemptionsRestartWorkflowId redemptions restart workflow id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryRedemptionsRestartWorkflow: function (redemptionsRestartWorkflowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.queryRedemptionsRestartWorkflow(redemptionsRestartWorkflowId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Redeem a reward
         * @param {string} rewardLogicId
         * @param {RedeemRewardRequest} redeemRewardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemReward: function (rewardLogicId, redeemRewardRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.redeemReward(rewardLogicId, redeemRewardRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Restart a set of redemptions
         * @param {string} jakProject
         * @param {RestartRedemptionsRequest} restartRedemptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartRedemptionWorkflows: function (jakProject, restartRedemptionsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.restartRedemptionWorkflows(jakProject, restartRedemptionsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [walletLogicId]
         * @param {Array<string>} [initiativeLogicId]
         * @param {string} [transactionDateStart]
         * @param {string} [transactionDateEnd]
         * @param {number} [minAmount]
         * @param {number} [maxAmount]
         * @param {Array<string>} [statusExternalIds]
         * @param {Array<string>} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransaction: function (page, size, includeMetadata, walletLogicId, initiativeLogicId, transactionDateStart, transactionDateEnd, minAmount, maxAmount, statusExternalIds, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchTransaction(page, size, includeMetadata, walletLogicId, initiativeLogicId, transactionDateStart, transactionDateEnd, minAmount, maxAmount, statusExternalIds, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a Attribute
         * @param {string} attributeLogicId Attribute logic id
         * @param {UpdateAttributeRequest} [updateAttributeRequest] Update Attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttribute: function (attributeLogicId, updateAttributeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAttribute(attributeLogicId, updateAttributeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a brand
         * @param {string} brandLogicId brand logic id
         * @param {UpdateBrandRequest} [updateBrandRequest] Update brand request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand: function (brandLogicId, updateBrandRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBrand(brandLogicId, updateBrandRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a brand category
         * @param {string} brandCategoryLogicId brand category logic id
         * @param {UpdateBrandCategoryRequest} [updateBrandCategoryRequest] Update brand category request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandCategory: function (brandCategoryLogicId, updateBrandCategoryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBrandCategory(brandCategoryLogicId, updateBrandCategoryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update catalogGroupOProduct\'s properties
         * @param {string} catalogGroupLogicId
         * @param {string} catalogProductLogicId
         * @param {UpdateCatalogGroupProductRequest} [updateCatalogGroupProductRequest] Update catalog-group-product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroupProduct: function (catalogGroupLogicId, catalogProductLogicId, updateCatalogGroupProductRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCatalogGroupProduct(catalogGroupLogicId, catalogProductLogicId, updateCatalogGroupProductRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Modify a category for idCategory
         * @param {string} logicId category logic id
         * @param {UpdateClusterCategoryRequest} updateClusterCategoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryById: function (logicId, updateClusterCategoryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCategoryById(logicId, updateClusterCategoryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing cluster:  The Backoffice modify an existing cluster
         * @param {string} logicId cluster logic id
         * @param {UpdateClusterRequest} updateClusterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClusterById: function (logicId, updateClusterRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateClusterById(logicId, updateClusterRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a liquidation
         * @param {string} liquidationLogicId liquidation logic id
         * @param {LiquidationDto} [liquidationDto] Update liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLiquidation: function (liquidationLogicId, liquidationDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLiquidation(liquidationLogicId, liquidationDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a partner
         * @param {string} partnerLogicId partner logic id
         * @param {UpdatePartnerRequest} [updatePartnerRequest] Update partner request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner: function (partnerLogicId, updatePartnerRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePartner(partnerLogicId, updatePartnerRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a product
         * @param {string} productLogicId product logic id
         * @param {UpdateProductRequest} [updateProductRequest] Update product request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (productLogicId, updateProductRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProduct(productLogicId, updateProductRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Product Fee
         * @param {string} catalogProductLogicId
         * @param {UpdateProductFeesRequest} [updateProductFeesRequest] Update product fees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductFees: function (catalogProductLogicId, updateProductFeesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProductFees(catalogProductLogicId, updateProductFeesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update product purchase parameter
         * @param {string} productLogicId product logic id
         * @param {UpdateProductPurchaseParamRequest} [updateProductPurchaseParamRequest] Associate purchase param request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductPurchaseParameter: function (productLogicId, updateProductPurchaseParamRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProductPurchaseParameter(productLogicId, updateProductPurchaseParamRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a purchase param
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {UpdatePurchaseParamRequest} [updatePurchaseParamRequest] Update purchaseParam request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseParam: function (purchaseParamLogicId, updatePurchaseParamRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePurchaseParam(purchaseParamLogicId, updatePurchaseParamRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a supplier
         * @param {string} supplierLogicId supplier logic id
         * @param {UpdateSupplierRequest} [updateSupplierRequest] Update supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplier: function (supplierLogicId, updateSupplierRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSupplier(supplierLogicId, updateSupplierRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Modify a wallet configuration for idWalletConfiguration
         * @param {string} idLogic id configuration
         * @param {WalletConfigurationRequest} walletConfigurationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWalletConfById: function (idLogic, walletConfigurationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateWalletConfById(idLogic, walletConfigurationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upsert Attribute in a specific flow
         * @param {string} jakProject
         * @param {UpsertAttributeCfgRequestDto} upsertAttributeCfgRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertAttribute: function (jakProject, upsertAttributeCfgRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertAttribute(jakProject, upsertAttributeCfgRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post a new flow for a specific cluster:  The Backoffice create or update a new cluster flow
         * @param {string} clusterLogicId cluster logic id
         * @param {string} jakProject
         * @param {UpsertClusterFlowRequestDto} upsertClusterFlowRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertClusterFlow: function (clusterLogicId, jakProject, upsertClusterFlowRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertClusterFlow(clusterLogicId, jakProject, upsertClusterFlowRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upsert Status with StatusRoute
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {StatusesListForProjectDto} statusesListForProjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStatus: function (jakProject, jakTenant, statusesListForProjectDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertStatus(jakProject, jakTenant, statusesListForProjectDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
var AdminApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         *
         * @summary associate product display rule to catalog group product through the pair catalogProduct/catalogGroup
         * @param {string} catalogLogicId
         * @param {string} catalogProductLogicId
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} productDisplayRuleLogicIds list of comma separated product display rule logic ids to associate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssociateProductDisplayRules: function (catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options) {
            return localVarFp.adminAssociateProductDisplayRules(catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Bundling products
         * @param {string} productLogicId product logic id
         * @param {BundlingProductsRequest} [bundlingProductsRequest] Bundling products request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBundlingProducts: function (productLogicId, bundlingProductsRequest, options) {
            return localVarFp.adminBundlingProducts(productLogicId, bundlingProductsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a product display
         * @param {ProductDisplayRuleDto} [productDisplayRuleDto] Creates a product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateProductDisplay: function (productDisplayRuleDto, options) {
            return localVarFp.adminCreateProductDisplay(productDisplayRuleDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete product display rule and its associations
         * @param {string} logicId logicId of the product display to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteProductDisplayRule: function (logicId, options) {
            return localVarFp.adminDeleteProductDisplayRule(logicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary dissociate product display rule from catalog group product through the pair catalogProduct/catalogGroup
         * @param {string} catalogLogicId
         * @param {string} catalogProductLogicId
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} productDisplayRuleLogicIds list of comma separated product display rule logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDissociateProductDisplayRules: function (catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options) {
            return localVarFp.adminDissociateProductDisplayRules(catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary search a product display
         * @param {string} logicId search a product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductDisplayRule: function (logicId, options) {
            return localVarFp.adminGetProductDisplayRule(logicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Relatable products
         * @param {string} productLogicId
         * @param {RelationTypeEnum} relationType
         * @param {Array<string>} [productAttributeLogicIds] list of comma separated product attribute logic ids
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRelatableProducts: function (productLogicId, relationType, productAttributeLogicIds, sort, page, size, includeMetadata, options) {
            return localVarFp.adminRelatableProducts(productLogicId, relationType, productAttributeLogicIds, sort, page, size, includeMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unbundling products
         * @param {string} productLogicId
         * @param {Array<string>} productLogicIds list of comma separated product logic ids to unbund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUnbundlingProducts: function (productLogicId, productLogicIds, options) {
            return localVarFp.adminUnbundlingProducts(productLogicId, productLogicIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary update productDisplay
         * @param {string} logicId logicId of product display to update
         * @param {ProductDisplayRuleDto} [productDisplayRuleDto] Update product display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductDisplay: function (logicId, productDisplayRuleDto, options) {
            return localVarFp.adminUpdateProductDisplay(logicId, productDisplayRuleDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Associates products and catalog-group - liquidation and availability left unset
         * @param {string} catalogGroupLogicId
         * @param {AssociateCatalogGroupProductsRequest} [associateCatalogGroupProductsRequest] Create catalog-group-products associations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateCatalogGroupProducts: function (catalogGroupLogicId, associateCatalogGroupProductsRequest, options) {
            return localVarFp.associateCatalogGroupProducts(catalogGroupLogicId, associateCatalogGroupProductsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Associates products and catalog - creates product fee initialized to 0
         * @param {string} catalogLogicId
         * @param {AssociateCatalogProductsRequest} [associateCatalogProductsRequest] Create catalog-products associations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateCatalogProducts: function (catalogLogicId, associateCatalogProductsRequest, options) {
            return localVarFp.associateCatalogProducts(catalogLogicId, associateCatalogProductsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Associate attribute to a product
         * @param {string} productLogicId product logic id
         * @param {AttributeProductsRequest} [attributeProductsRequest] product attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateProductAttribute: function (productLogicId, attributeProductsRequest, options) {
            return localVarFp.associateProductAttribute(productLogicId, attributeProductsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Associates a purchase parameter to a product
         * @param {string} productLogicId product logic id
         * @param {AssociatePurchaseParamRequest} [associatePurchaseParamRequest] Associate purchase param request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associatePurchaseParam: function (productLogicId, associatePurchaseParamRequest, options) {
            return localVarFp.associatePurchaseParam(productLogicId, associatePurchaseParamRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Changes a partner status
         * @param {string} partnerLogicId partner logic id
         * @param {ChangePartnerStatusRequest} [changePartnerStatusRequest] Changes a partner status (ACTIVE or DELETED)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePartnerStatus: function (partnerLogicId, changePartnerStatusRequest, options) {
            return localVarFp.changePartnerStatus(partnerLogicId, changePartnerStatusRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Changes a product status
         * @param {string} productLogicId product logic id
         * @param {ChangeProductStatusRequest} [changeProductStatusRequest] Changes a product status (ACTIVE or DELETED)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeProductStatus: function (productLogicId, changeProductStatusRequest, options) {
            return localVarFp.changeProductStatus(productLogicId, changeProductStatusRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a Attribute
         * @param {CreateAttributeRequest} [createAttributeRequest] Create attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttribute: function (createAttributeRequest, options) {
            return localVarFp.createAttribute(createAttributeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a brand
         * @param {CreateBrandRequest} [createBrandRequest] Create brand request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: function (createBrandRequest, options) {
            return localVarFp.createBrand(createBrandRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a brand category
         * @param {CreateBrandCategoryRequest} [createBrandCategoryRequest] Create brand category request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandCategory: function (createBrandCategoryRequest, options) {
            return localVarFp.createBrandCategory(createBrandCategoryRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a Liquidation
         * @param {LiquidationRequest} [liquidationRequest] Create Liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLiquidation: function (liquidationRequest, options) {
            return localVarFp.createLiquidation(liquidationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a partner
         * @param {CreatePartnerRequest} [createPartnerRequest] Create partner request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner: function (createPartnerRequest, options) {
            return localVarFp.createPartner(createPartnerRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a product
         * @param {CreateProductRequest} [createProductRequest] Create product request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (createProductRequest, options) {
            return localVarFp.createProduct(createProductRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a purchase param
         * @param {CreatePurchaseParamRequest} [createPurchaseParamRequest] Create purchaseParam request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseParam: function (createPurchaseParamRequest, options) {
            return localVarFp.createPurchaseParam(createPurchaseParamRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a supplier
         * @param {CreateSupplierRequest} [createSupplierRequest] Create supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplier: function (createSupplierRequest, options) {
            return localVarFp.createSupplier(createSupplierRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a Attribute if there are no products associated
         * @param {string} attributeLogicId Attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttribute: function (attributeLogicId, options) {
            return localVarFp.deleteAttribute(attributeLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a Attribute if there are no products associated
         * @param {string} attributeValueLogicId Attribute Value logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributeValue: function (attributeValueLogicId, options) {
            return localVarFp.deleteAttributeValue(attributeValueLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a brand if there are no products associated
         * @param {string} brandLogicId brand logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand: function (brandLogicId, options) {
            return localVarFp.deleteBrand(brandLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete a category for idCategory
         * @param {string} logicId category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryById: function (logicId, options) {
            return localVarFp.deleteCategoryById(logicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete the attribute from a specific flow
         * @summary Delete the attribute from a specific flow
         * @param {string} attributeLogicId
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterAttributeFlow: function (attributeLogicId, clusterFlowLogicId, options) {
            return localVarFp.deleteClusterAttributeFlow(attributeLogicId, clusterFlowLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an existing cluster:  The Backoffice modify an existing cluster
         * @param {string} logicId cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterById: function (logicId, options) {
            return localVarFp.deleteClusterById(logicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete the cluster flow and the relation of attributes between the flow
         * @summary Delete the cluster flow and the relation of attributes between the flow
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClusterFlow: function (clusterFlowLogicId, options) {
            return localVarFp.deleteClusterFlow(clusterFlowLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a sector if there are no products associated
         * @param {string} liquidationLogicId liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLiquidation: function (liquidationLogicId, options) {
            return localVarFp.deleteLiquidation(liquidationLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete attribute to a product
         * @param {string} productLogicId product logic id
         * @param {string} productAttributeLogicId product attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductAttribute: function (productLogicId, productAttributeLogicId, options) {
            return localVarFp.deleteProductAttribute(productLogicId, productAttributeLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a purchase param if there are no products associated
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseParam: function (purchaseParamLogicId, options) {
            return localVarFp.deletePurchaseParam(purchaseParamLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete the single status
         * @summary Delete the single status
         * @param {string} statusLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus: function (statusLogicId, options) {
            return localVarFp.deleteStatus(statusLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete the single status route for a status
         * @summary Delete the single status route for a status
         * @param {string} statusLogicId
         * @param {string} statusRouteLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatusRouteForStatus: function (statusLogicId, statusRouteLogicId, options) {
            return localVarFp.deleteStatusRouteForStatus(statusLogicId, statusRouteLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a supplier if there are no products associated
         * @param {string} supplierLogicId supplier logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplier: function (supplierLogicId, options) {
            return localVarFp.deleteSupplier(supplierLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete a wallet configuration for idWalletConfig
         * @param {string} idLogic id configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWalletConfById: function (idLogic, options) {
            return localVarFp.deleteWalletConfById(idLogic, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Disassociates a purchase parameter from a product
         * @param {string} productLogicId product logic id
         * @param {string} purchaseParameterLogicId purchaseParameter logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disassociatePurchaseParam: function (productLogicId, purchaseParameterLogicId, options) {
            return localVarFp.disassociatePurchaseParam(productLogicId, purchaseParameterLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Dissociates products and catalog group
         * @param {string} catalogGroupLogicId
         * @param {Array<string>} catalogProductLogicIds list of comma separated catalog product logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dissociateCatalogGroupProducts: function (catalogGroupLogicId, catalogProductLogicIds, options) {
            return localVarFp.dissociateCatalogGroupProducts(catalogGroupLogicId, catalogProductLogicIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Dissociates products and catalog
         * @param {string} catalogLogicId
         * @param {Array<string>} productLogicIds list of comma separated product logic ids to dissociate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dissociateCatalogProducts: function (catalogLogicId, productLogicIds, options) {
            return localVarFp.dissociateCatalogProducts(catalogLogicId, productLogicIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of all attributes available on JNext Platform, the list of attributes configured for a project, the list of attribute related with the cluster, and the list of cms related to the attribute
         * @summary Get all the attributes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAttributes: function (options) {
            return localVarFp.getAllAttributes(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of all categories:  The Backoffice returns the list of all categories
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCategories: function (page, size, options) {
            return localVarFp.getAllCategories(page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of all clusters for specific category logic id:  The Backoffice returns the list of all clusters for specific category logic id
         * @param {string} logicIdCategory category logic id
         * @param {string} [page] Current page number
         * @param {string} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClustersByCategoryLogicId: function (logicIdCategory, page, size, options) {
            return localVarFp.getAllClustersByCategoryLogicId(logicIdCategory, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get clusters configurations for wallets
         * @summary get clusters configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClustersWalletsConf: function (options) {
            return localVarFp.getAllClustersWalletsConf(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get currencies configurations for wallets
         * @summary get currencies configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCurrenciesWalletsConf: function (options) {
            return localVarFp.getAllCurrenciesWalletsConf(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get reset-strategy configurations for wallets
         * @summary get reset-strategy configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResetStrategyWalletsConf: function (options) {
            return localVarFp.getAllResetStrategyWalletsConf(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of all wallets configurations:  The Backoffice returns the list of all wallets configurations
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {boolean} [includeGenerated] if true, include Fl generated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWalletConf: function (page, size, includeGenerated, options) {
            return localVarFp.getAllWalletConf(page, size, includeGenerated, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get wallets-type configurations for wallets
         * @summary get wallets-type configurations for wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWalletsTypeWalletsConf: function (options) {
            return localVarFp.getAllWalletsTypeWalletsConf(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a Attribute
         * @param {string} attributeLogicId Attribute logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttribute: function (attributeLogicId, options) {
            return localVarFp.getAttribute(attributeLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves all attributes
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes: function (page, size, includeMetadata, sort, options) {
            return localVarFp.getAttributes(page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of default attribute avalaible on jNext platform
         * @summary Get the list of default attribute avalaible on jNext platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesDefault: function (options) {
            return localVarFp.getAttributesDefault(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a brand
         * @param {string} brandLogicId brand logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand: function (brandLogicId, options) {
            return localVarFp.getBrand(brandLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged brand categories filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] brand category name (LIKE mode)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCategories: function (page, size, includeMetadata, sort, name, options) {
            return localVarFp.getBrandCategories(page, size, includeMetadata, sort, name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a brand category
         * @param {string} brandCategoryLogicId brand category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCategory: function (brandCategoryLogicId, options) {
            return localVarFp.getBrandCategory(brandCategoryLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged brands filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] brand name (LIKE mode)
         * @param {string} [partnerLogicId] filter by exact partner logic id
         * @param {string} [brandCategoryLogicId] filter by exact brand category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands: function (page, size, includeMetadata, sort, name, partnerLogicId, brandCategoryLogicId, options) {
            return localVarFp.getBrands(page, size, includeMetadata, sort, name, partnerLogicId, brandCategoryLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a category for idCategory
         * @param {string} logicId category logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById: function (logicId, options) {
            return localVarFp.getCategoryById(logicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all the attributes related to a cluster and clusterFlow
         * @summary Get all the attributes related to a cluster and clusterFlow
         * @param {string} clusterLogicId
         * @param {string} clusterFlowLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterAttributesFlow: function (clusterLogicId, clusterFlowLogicId, options) {
            return localVarFp.getClusterAttributesFlow(clusterLogicId, clusterFlowLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a cluster for clusterLogicId
         * @param {string} logicId cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterById: function (logicId, options) {
            return localVarFp.getClusterById(logicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of all flows related to a specific cluster or all the cluster of the project
         * @param {string} [clusterLogicId] cluster logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClusterFlows: function (clusterLogicId, options) {
            return localVarFp.getClusterFlows(clusterLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get all the flows type availabe on JNext Platform
         * @summary get all flows type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowTypeList: function (options) {
            return localVarFp.getFlowTypeList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a liquidation
         * @param {string} liquidationLogicId Liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiquidation: function (liquidationLogicId, options) {
            return localVarFp.getLiquidation(liquidationLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged liquidations filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [type] type of the liquidation param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiquidations: function (page, size, includeMetadata, sort, type, options) {
            return localVarFp.getLiquidations(page, size, includeMetadata, sort, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a partner
         * @param {string} partnerLogicId partner logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartner: function (partnerLogicId, options) {
            return localVarFp.getPartner(partnerLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged partners filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] partner name (LIKE mode)
         * @param {string} [status] partner status
         * @param {string} [catalogLogicId] catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartners: function (page, size, includeMetadata, sort, name, status, catalogLogicId, options) {
            return localVarFp.getPartners(page, size, includeMetadata, sort, name, status, catalogLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a product
         * @param {string} productLogicId product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (productLogicId, options) {
            return localVarFp.getProduct(productLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves purchase parameters associated to a product
         * @param {string} productLogicId product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPurchaseParams: function (productLogicId, options) {
            return localVarFp.getProductPurchaseParams(productLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged products filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [sku] product sku (LIKE mode)
         * @param {string} [logicId] product logicId
         * @param {string} [externalId] product externalId (LIKE mode)
         * @param {string} [name] product name (LIKE mode)
         * @param {string} [partnerLogicId] product partnerLogicId
         * @param {string} [brandLogicId] product brandLogicId
         * @param {string} [supplierLogicId] product supplierLogicId
         * @param {string} [status] product status
         * @param {string} [relationType] product relationType
         * @param {string} [productType] product productType
         * @param {number} [minPurchasePrice] product minPurchasePrice
         * @param {number} [maxPurchasePrice] product maxPurchasePrice
         * @param {string} [excludeInCatalogLogicId] Get only available products not already in the catalogue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (page, size, includeMetadata, sort, sku, logicId, externalId, name, partnerLogicId, brandLogicId, supplierLogicId, status, relationType, productType, minPurchasePrice, maxPurchasePrice, excludeInCatalogLogicId, options) {
            return localVarFp.getProducts(page, size, includeMetadata, sort, sku, logicId, externalId, name, partnerLogicId, brandLogicId, supplierLogicId, status, relationType, productType, minPurchasePrice, maxPurchasePrice, excludeInCatalogLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a purchase param
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParam: function (purchaseParamLogicId, options) {
            return localVarFp.getPurchaseParam(purchaseParamLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged purchase params filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [type] type of the purhcase param
         * @param {string} [hurlId] hurlId of the purhcase param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParams: function (page, size, includeMetadata, sort, type, hurlId, options) {
            return localVarFp.getPurchaseParams(page, size, includeMetadata, sort, type, hurlId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the single status
         * @summary Get the single status
         * @param {string} statusLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: function (statusLogicId, options) {
            return localVarFp.getStatus(statusLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of status for a project
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusList: function (jakProject, jakTenant, options) {
            return localVarFp.getStatusList(jakProject, jakTenant, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of status routes for a status
         * @param {string} statusLogicId
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusRouteForStatusList: function (statusLogicId, jakProject, jakTenant, options) {
            return localVarFp.getStatusRouteForStatusList(statusLogicId, jakProject, jakTenant, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a supplier
         * @param {string} supplierLogicId supplier logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier: function (supplierLogicId, options) {
            return localVarFp.getSupplier(supplierLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged suppliers filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [name] supplier name (LIKE mode)
         * @param {string} [partnerLogicId] filter by exact partner logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliers: function (page, size, includeMetadata, sort, name, partnerLogicId, options) {
            return localVarFp.getSuppliers(page, size, includeMetadata, sort, name, partnerLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a wallet configuration:  The Backoffice return a wallet configuration by specific id
         * @param {string} idLogic id configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletConfById: function (idLogic, options) {
            return localVarFp.getWalletConfById(idLogic, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post a new category:  The Backoffice create a new category
         * @param {CreateClusterCategoryRequest} createClusterCategoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCategory: function (createClusterCategoryRequest, options) {
            return localVarFp.insertCategory(createClusterCategoryRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post a new cluster for a specific category:  The Backoffice create a new cluster
         * @param {string} logicIdCategory category logic id
         * @param {CreateClusterRequest} createClusterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCluster: function (logicIdCategory, createClusterRequest, options) {
            return localVarFp.insertCluster(logicIdCategory, createClusterRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Insert Status routes for a status
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {StatusesRouteListForStatusDto} statusesRouteListForStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertStatusRouteForStatus: function (jakProject, jakTenant, statusesRouteListForStatusDto, options) {
            return localVarFp.insertStatusRouteForStatus(jakProject, jakTenant, statusesRouteListForStatusDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post a new wallet configuration:  The Backoffice create a new wallet configuration
         * @param {WalletConfigurationRequest} walletConfigurationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWalletConf: function (walletConfigurationRequest, options) {
            return localVarFp.insertWalletConf(walletConfigurationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary modify status for a specific idCategory
         * @param {string} logicId category logic id
         * @param {UpdateClusterCategoryStatusRequestChildDto} updateClusterCategoryStatusRequestChildDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStatusCategoryById: function (logicId, updateClusterCategoryStatusRequestChildDto, options) {
            return localVarFp.patchStatusCategoryById(logicId, updateClusterCategoryStatusRequestChildDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of all attributes available on JNext Platform, the list of attributes configured for a project, the list of attribute related with the cluster, and the list of cms related to the attribute
         * @summary Get all the attributes
         * @param {string} redemptionsRestartWorkflowId redemptions restart workflow id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryRedemptionsRestartWorkflow: function (redemptionsRestartWorkflowId, options) {
            return localVarFp.queryRedemptionsRestartWorkflow(redemptionsRestartWorkflowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Redeem a reward
         * @param {string} rewardLogicId
         * @param {RedeemRewardRequest} redeemRewardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemReward: function (rewardLogicId, redeemRewardRequest, options) {
            return localVarFp.redeemReward(rewardLogicId, redeemRewardRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Restart a set of redemptions
         * @param {string} jakProject
         * @param {RestartRedemptionsRequest} restartRedemptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartRedemptionWorkflows: function (jakProject, restartRedemptionsRequest, options) {
            return localVarFp.restartRedemptionWorkflows(jakProject, restartRedemptionsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [walletLogicId]
         * @param {Array<string>} [initiativeLogicId]
         * @param {string} [transactionDateStart]
         * @param {string} [transactionDateEnd]
         * @param {number} [minAmount]
         * @param {number} [maxAmount]
         * @param {Array<string>} [statusExternalIds]
         * @param {Array<string>} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransaction: function (page, size, includeMetadata, walletLogicId, initiativeLogicId, transactionDateStart, transactionDateEnd, minAmount, maxAmount, statusExternalIds, userId, options) {
            return localVarFp.searchTransaction(page, size, includeMetadata, walletLogicId, initiativeLogicId, transactionDateStart, transactionDateEnd, minAmount, maxAmount, statusExternalIds, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a Attribute
         * @param {string} attributeLogicId Attribute logic id
         * @param {UpdateAttributeRequest} [updateAttributeRequest] Update Attribute request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttribute: function (attributeLogicId, updateAttributeRequest, options) {
            return localVarFp.updateAttribute(attributeLogicId, updateAttributeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a brand
         * @param {string} brandLogicId brand logic id
         * @param {UpdateBrandRequest} [updateBrandRequest] Update brand request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand: function (brandLogicId, updateBrandRequest, options) {
            return localVarFp.updateBrand(brandLogicId, updateBrandRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a brand category
         * @param {string} brandCategoryLogicId brand category logic id
         * @param {UpdateBrandCategoryRequest} [updateBrandCategoryRequest] Update brand category request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandCategory: function (brandCategoryLogicId, updateBrandCategoryRequest, options) {
            return localVarFp.updateBrandCategory(brandCategoryLogicId, updateBrandCategoryRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update catalogGroupOProduct\'s properties
         * @param {string} catalogGroupLogicId
         * @param {string} catalogProductLogicId
         * @param {UpdateCatalogGroupProductRequest} [updateCatalogGroupProductRequest] Update catalog-group-product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroupProduct: function (catalogGroupLogicId, catalogProductLogicId, updateCatalogGroupProductRequest, options) {
            return localVarFp.updateCatalogGroupProduct(catalogGroupLogicId, catalogProductLogicId, updateCatalogGroupProductRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Modify a category for idCategory
         * @param {string} logicId category logic id
         * @param {UpdateClusterCategoryRequest} updateClusterCategoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryById: function (logicId, updateClusterCategoryRequest, options) {
            return localVarFp.updateCategoryById(logicId, updateClusterCategoryRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an existing cluster:  The Backoffice modify an existing cluster
         * @param {string} logicId cluster logic id
         * @param {UpdateClusterRequest} updateClusterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClusterById: function (logicId, updateClusterRequest, options) {
            return localVarFp.updateClusterById(logicId, updateClusterRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a liquidation
         * @param {string} liquidationLogicId liquidation logic id
         * @param {LiquidationDto} [liquidationDto] Update liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLiquidation: function (liquidationLogicId, liquidationDto, options) {
            return localVarFp.updateLiquidation(liquidationLogicId, liquidationDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a partner
         * @param {string} partnerLogicId partner logic id
         * @param {UpdatePartnerRequest} [updatePartnerRequest] Update partner request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner: function (partnerLogicId, updatePartnerRequest, options) {
            return localVarFp.updatePartner(partnerLogicId, updatePartnerRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a product
         * @param {string} productLogicId product logic id
         * @param {UpdateProductRequest} [updateProductRequest] Update product request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (productLogicId, updateProductRequest, options) {
            return localVarFp.updateProduct(productLogicId, updateProductRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Product Fee
         * @param {string} catalogProductLogicId
         * @param {UpdateProductFeesRequest} [updateProductFeesRequest] Update product fees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductFees: function (catalogProductLogicId, updateProductFeesRequest, options) {
            return localVarFp.updateProductFees(catalogProductLogicId, updateProductFeesRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update product purchase parameter
         * @param {string} productLogicId product logic id
         * @param {UpdateProductPurchaseParamRequest} [updateProductPurchaseParamRequest] Associate purchase param request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductPurchaseParameter: function (productLogicId, updateProductPurchaseParamRequest, options) {
            return localVarFp.updateProductPurchaseParameter(productLogicId, updateProductPurchaseParamRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a purchase param
         * @param {string} purchaseParamLogicId purchaseParam logic id
         * @param {UpdatePurchaseParamRequest} [updatePurchaseParamRequest] Update purchaseParam request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseParam: function (purchaseParamLogicId, updatePurchaseParamRequest, options) {
            return localVarFp.updatePurchaseParam(purchaseParamLogicId, updatePurchaseParamRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a supplier
         * @param {string} supplierLogicId supplier logic id
         * @param {UpdateSupplierRequest} [updateSupplierRequest] Update supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplier: function (supplierLogicId, updateSupplierRequest, options) {
            return localVarFp.updateSupplier(supplierLogicId, updateSupplierRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Modify a wallet configuration for idWalletConfiguration
         * @param {string} idLogic id configuration
         * @param {WalletConfigurationRequest} walletConfigurationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWalletConfById: function (idLogic, walletConfigurationRequest, options) {
            return localVarFp.updateWalletConfById(idLogic, walletConfigurationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upsert Attribute in a specific flow
         * @param {string} jakProject
         * @param {UpsertAttributeCfgRequestDto} upsertAttributeCfgRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertAttribute: function (jakProject, upsertAttributeCfgRequestDto, options) {
            return localVarFp.upsertAttribute(jakProject, upsertAttributeCfgRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post a new flow for a specific cluster:  The Backoffice create or update a new cluster flow
         * @param {string} clusterLogicId cluster logic id
         * @param {string} jakProject
         * @param {UpsertClusterFlowRequestDto} upsertClusterFlowRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertClusterFlow: function (clusterLogicId, jakProject, upsertClusterFlowRequestDto, options) {
            return localVarFp.upsertClusterFlow(clusterLogicId, jakProject, upsertClusterFlowRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upsert Status with StatusRoute
         * @param {string} jakProject
         * @param {string} jakTenant
         * @param {StatusesListForProjectDto} statusesListForProjectDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStatus: function (jakProject, jakTenant, statusesListForProjectDto, options) {
            return localVarFp.upsertStatus(jakProject, jakTenant, statusesListForProjectDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
var AdminApi = /** @class */ (function (_super) {
    __extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary associate product display rule to catalog group product through the pair catalogProduct/catalogGroup
     * @param {string} catalogLogicId
     * @param {string} catalogProductLogicId
     * @param {string} catalogGroupLogicId
     * @param {Array<string>} productDisplayRuleLogicIds list of comma separated product display rule logic ids to associate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminAssociateProductDisplayRules = function (catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminAssociateProductDisplayRules(catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Bundling products
     * @param {string} productLogicId product logic id
     * @param {BundlingProductsRequest} [bundlingProductsRequest] Bundling products request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminBundlingProducts = function (productLogicId, bundlingProductsRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminBundlingProducts(productLogicId, bundlingProductsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a product display
     * @param {ProductDisplayRuleDto} [productDisplayRuleDto] Creates a product display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminCreateProductDisplay = function (productDisplayRuleDto, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminCreateProductDisplay(productDisplayRuleDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete product display rule and its associations
     * @param {string} logicId logicId of the product display to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminDeleteProductDisplayRule = function (logicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminDeleteProductDisplayRule(logicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary dissociate product display rule from catalog group product through the pair catalogProduct/catalogGroup
     * @param {string} catalogLogicId
     * @param {string} catalogProductLogicId
     * @param {string} catalogGroupLogicId
     * @param {Array<string>} productDisplayRuleLogicIds list of comma separated product display rule logic ids to dissociate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminDissociateProductDisplayRules = function (catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminDissociateProductDisplayRules(catalogLogicId, catalogProductLogicId, catalogGroupLogicId, productDisplayRuleLogicIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary search a product display
     * @param {string} logicId search a product display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminGetProductDisplayRule = function (logicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminGetProductDisplayRule(logicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Relatable products
     * @param {string} productLogicId
     * @param {RelationTypeEnum} relationType
     * @param {Array<string>} [productAttributeLogicIds] list of comma separated product attribute logic ids
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminRelatableProducts = function (productLogicId, relationType, productAttributeLogicIds, sort, page, size, includeMetadata, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminRelatableProducts(productLogicId, relationType, productAttributeLogicIds, sort, page, size, includeMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Unbundling products
     * @param {string} productLogicId
     * @param {Array<string>} productLogicIds list of comma separated product logic ids to unbund
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminUnbundlingProducts = function (productLogicId, productLogicIds, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminUnbundlingProducts(productLogicId, productLogicIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary update productDisplay
     * @param {string} logicId logicId of product display to update
     * @param {ProductDisplayRuleDto} [productDisplayRuleDto] Update product display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminUpdateProductDisplay = function (logicId, productDisplayRuleDto, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminUpdateProductDisplay(logicId, productDisplayRuleDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Associates products and catalog-group - liquidation and availability left unset
     * @param {string} catalogGroupLogicId
     * @param {AssociateCatalogGroupProductsRequest} [associateCatalogGroupProductsRequest] Create catalog-group-products associations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.associateCatalogGroupProducts = function (catalogGroupLogicId, associateCatalogGroupProductsRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).associateCatalogGroupProducts(catalogGroupLogicId, associateCatalogGroupProductsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Associates products and catalog - creates product fee initialized to 0
     * @param {string} catalogLogicId
     * @param {AssociateCatalogProductsRequest} [associateCatalogProductsRequest] Create catalog-products associations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.associateCatalogProducts = function (catalogLogicId, associateCatalogProductsRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).associateCatalogProducts(catalogLogicId, associateCatalogProductsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Associate attribute to a product
     * @param {string} productLogicId product logic id
     * @param {AttributeProductsRequest} [attributeProductsRequest] product attribute request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.associateProductAttribute = function (productLogicId, attributeProductsRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).associateProductAttribute(productLogicId, attributeProductsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Associates a purchase parameter to a product
     * @param {string} productLogicId product logic id
     * @param {AssociatePurchaseParamRequest} [associatePurchaseParamRequest] Associate purchase param request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.associatePurchaseParam = function (productLogicId, associatePurchaseParamRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).associatePurchaseParam(productLogicId, associatePurchaseParamRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Changes a partner status
     * @param {string} partnerLogicId partner logic id
     * @param {ChangePartnerStatusRequest} [changePartnerStatusRequest] Changes a partner status (ACTIVE or DELETED)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.changePartnerStatus = function (partnerLogicId, changePartnerStatusRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).changePartnerStatus(partnerLogicId, changePartnerStatusRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Changes a product status
     * @param {string} productLogicId product logic id
     * @param {ChangeProductStatusRequest} [changeProductStatusRequest] Changes a product status (ACTIVE or DELETED)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.changeProductStatus = function (productLogicId, changeProductStatusRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).changeProductStatus(productLogicId, changeProductStatusRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a Attribute
     * @param {CreateAttributeRequest} [createAttributeRequest] Create attribute request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createAttribute = function (createAttributeRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createAttribute(createAttributeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a brand
     * @param {CreateBrandRequest} [createBrandRequest] Create brand request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createBrand = function (createBrandRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createBrand(createBrandRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a brand category
     * @param {CreateBrandCategoryRequest} [createBrandCategoryRequest] Create brand category request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createBrandCategory = function (createBrandCategoryRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createBrandCategory(createBrandCategoryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a Liquidation
     * @param {LiquidationRequest} [liquidationRequest] Create Liquidation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createLiquidation = function (liquidationRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createLiquidation(liquidationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a partner
     * @param {CreatePartnerRequest} [createPartnerRequest] Create partner request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createPartner = function (createPartnerRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createPartner(createPartnerRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a product
     * @param {CreateProductRequest} [createProductRequest] Create product request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createProduct = function (createProductRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createProduct(createProductRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a purchase param
     * @param {CreatePurchaseParamRequest} [createPurchaseParamRequest] Create purchaseParam request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createPurchaseParam = function (createPurchaseParamRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createPurchaseParam(createPurchaseParamRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a supplier
     * @param {CreateSupplierRequest} [createSupplierRequest] Create supplier request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createSupplier = function (createSupplierRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createSupplier(createSupplierRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a Attribute if there are no products associated
     * @param {string} attributeLogicId Attribute logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteAttribute = function (attributeLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteAttribute(attributeLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a Attribute if there are no products associated
     * @param {string} attributeValueLogicId Attribute Value logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteAttributeValue = function (attributeValueLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteAttributeValue(attributeValueLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a brand if there are no products associated
     * @param {string} brandLogicId brand logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteBrand = function (brandLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteBrand(brandLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete a category for idCategory
     * @param {string} logicId category logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteCategoryById = function (logicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteCategoryById(logicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete the attribute from a specific flow
     * @summary Delete the attribute from a specific flow
     * @param {string} attributeLogicId
     * @param {string} clusterFlowLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteClusterAttributeFlow = function (attributeLogicId, clusterFlowLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteClusterAttributeFlow(attributeLogicId, clusterFlowLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an existing cluster:  The Backoffice modify an existing cluster
     * @param {string} logicId cluster logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteClusterById = function (logicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteClusterById(logicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete the cluster flow and the relation of attributes between the flow
     * @summary Delete the cluster flow and the relation of attributes between the flow
     * @param {string} clusterFlowLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteClusterFlow = function (clusterFlowLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteClusterFlow(clusterFlowLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a sector if there are no products associated
     * @param {string} liquidationLogicId liquidation logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteLiquidation = function (liquidationLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteLiquidation(liquidationLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete attribute to a product
     * @param {string} productLogicId product logic id
     * @param {string} productAttributeLogicId product attribute logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteProductAttribute = function (productLogicId, productAttributeLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteProductAttribute(productLogicId, productAttributeLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a purchase param if there are no products associated
     * @param {string} purchaseParamLogicId purchaseParam logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deletePurchaseParam = function (purchaseParamLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deletePurchaseParam(purchaseParamLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete the single status
     * @summary Delete the single status
     * @param {string} statusLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteStatus = function (statusLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteStatus(statusLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete the single status route for a status
     * @summary Delete the single status route for a status
     * @param {string} statusLogicId
     * @param {string} statusRouteLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteStatusRouteForStatus = function (statusLogicId, statusRouteLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteStatusRouteForStatus(statusLogicId, statusRouteLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a supplier if there are no products associated
     * @param {string} supplierLogicId supplier logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteSupplier = function (supplierLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteSupplier(supplierLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete a wallet configuration for idWalletConfig
     * @param {string} idLogic id configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteWalletConfById = function (idLogic, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteWalletConfById(idLogic, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Disassociates a purchase parameter from a product
     * @param {string} productLogicId product logic id
     * @param {string} purchaseParameterLogicId purchaseParameter logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.disassociatePurchaseParam = function (productLogicId, purchaseParameterLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).disassociatePurchaseParam(productLogicId, purchaseParameterLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Dissociates products and catalog group
     * @param {string} catalogGroupLogicId
     * @param {Array<string>} catalogProductLogicIds list of comma separated catalog product logic ids to dissociate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.dissociateCatalogGroupProducts = function (catalogGroupLogicId, catalogProductLogicIds, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).dissociateCatalogGroupProducts(catalogGroupLogicId, catalogProductLogicIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Dissociates products and catalog
     * @param {string} catalogLogicId
     * @param {Array<string>} productLogicIds list of comma separated product logic ids to dissociate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.dissociateCatalogProducts = function (catalogLogicId, productLogicIds, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).dissociateCatalogProducts(catalogLogicId, productLogicIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of all attributes available on JNext Platform, the list of attributes configured for a project, the list of attribute related with the cluster, and the list of cms related to the attribute
     * @summary Get all the attributes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAllAttributes = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAllAttributes(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of all categories:  The Backoffice returns the list of all categories
     * @param {number} [page] Current page number
     * @param {number} [size] Limits the number of returned items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAllCategories = function (page, size, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAllCategories(page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of all clusters for specific category logic id:  The Backoffice returns the list of all clusters for specific category logic id
     * @param {string} logicIdCategory category logic id
     * @param {string} [page] Current page number
     * @param {string} [size] Limits the number of returned items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAllClustersByCategoryLogicId = function (logicIdCategory, page, size, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAllClustersByCategoryLogicId(logicIdCategory, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get clusters configurations for wallets
     * @summary get clusters configurations for wallets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAllClustersWalletsConf = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAllClustersWalletsConf(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get currencies configurations for wallets
     * @summary get currencies configurations for wallets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAllCurrenciesWalletsConf = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAllCurrenciesWalletsConf(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get reset-strategy configurations for wallets
     * @summary get reset-strategy configurations for wallets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAllResetStrategyWalletsConf = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAllResetStrategyWalletsConf(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of all wallets configurations:  The Backoffice returns the list of all wallets configurations
     * @param {number} [page] Current page number
     * @param {number} [size] Limits the number of returned items
     * @param {boolean} [includeGenerated] if true, include Fl generated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAllWalletConf = function (page, size, includeGenerated, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAllWalletConf(page, size, includeGenerated, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get wallets-type configurations for wallets
     * @summary get wallets-type configurations for wallets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAllWalletsTypeWalletsConf = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAllWalletsTypeWalletsConf(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a Attribute
     * @param {string} attributeLogicId Attribute logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAttribute = function (attributeLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAttribute(attributeLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves all attributes
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAttributes = function (page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAttributes(page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of default attribute avalaible on jNext platform
     * @summary Get the list of default attribute avalaible on jNext platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getAttributesDefault = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getAttributesDefault(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a brand
     * @param {string} brandLogicId brand logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getBrand = function (brandLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getBrand(brandLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged brand categories filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {string} [name] brand category name (LIKE mode)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getBrandCategories = function (page, size, includeMetadata, sort, name, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getBrandCategories(page, size, includeMetadata, sort, name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a brand category
     * @param {string} brandCategoryLogicId brand category logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getBrandCategory = function (brandCategoryLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getBrandCategory(brandCategoryLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged brands filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {string} [name] brand name (LIKE mode)
     * @param {string} [partnerLogicId] filter by exact partner logic id
     * @param {string} [brandCategoryLogicId] filter by exact brand category logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getBrands = function (page, size, includeMetadata, sort, name, partnerLogicId, brandCategoryLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getBrands(page, size, includeMetadata, sort, name, partnerLogicId, brandCategoryLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a category for idCategory
     * @param {string} logicId category logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getCategoryById = function (logicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getCategoryById(logicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all the attributes related to a cluster and clusterFlow
     * @summary Get all the attributes related to a cluster and clusterFlow
     * @param {string} clusterLogicId
     * @param {string} clusterFlowLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getClusterAttributesFlow = function (clusterLogicId, clusterFlowLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getClusterAttributesFlow(clusterLogicId, clusterFlowLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a cluster for clusterLogicId
     * @param {string} logicId cluster logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getClusterById = function (logicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getClusterById(logicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of all flows related to a specific cluster or all the cluster of the project
     * @param {string} [clusterLogicId] cluster logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getClusterFlows = function (clusterLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getClusterFlows(clusterLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get all the flows type availabe on JNext Platform
     * @summary get all flows type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getFlowTypeList = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getFlowTypeList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a liquidation
     * @param {string} liquidationLogicId Liquidation logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getLiquidation = function (liquidationLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getLiquidation(liquidationLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged liquidations filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {string} [type] type of the liquidation param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getLiquidations = function (page, size, includeMetadata, sort, type, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getLiquidations(page, size, includeMetadata, sort, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a partner
     * @param {string} partnerLogicId partner logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getPartner = function (partnerLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getPartner(partnerLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged partners filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {string} [name] partner name (LIKE mode)
     * @param {string} [status] partner status
     * @param {string} [catalogLogicId] catalog logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getPartners = function (page, size, includeMetadata, sort, name, status, catalogLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getPartners(page, size, includeMetadata, sort, name, status, catalogLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a product
     * @param {string} productLogicId product logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getProduct = function (productLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getProduct(productLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves purchase parameters associated to a product
     * @param {string} productLogicId product logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getProductPurchaseParams = function (productLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getProductPurchaseParams(productLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged products filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {string} [sku] product sku (LIKE mode)
     * @param {string} [logicId] product logicId
     * @param {string} [externalId] product externalId (LIKE mode)
     * @param {string} [name] product name (LIKE mode)
     * @param {string} [partnerLogicId] product partnerLogicId
     * @param {string} [brandLogicId] product brandLogicId
     * @param {string} [supplierLogicId] product supplierLogicId
     * @param {string} [status] product status
     * @param {string} [relationType] product relationType
     * @param {string} [productType] product productType
     * @param {number} [minPurchasePrice] product minPurchasePrice
     * @param {number} [maxPurchasePrice] product maxPurchasePrice
     * @param {string} [excludeInCatalogLogicId] Get only available products not already in the catalogue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getProducts = function (page, size, includeMetadata, sort, sku, logicId, externalId, name, partnerLogicId, brandLogicId, supplierLogicId, status, relationType, productType, minPurchasePrice, maxPurchasePrice, excludeInCatalogLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getProducts(page, size, includeMetadata, sort, sku, logicId, externalId, name, partnerLogicId, brandLogicId, supplierLogicId, status, relationType, productType, minPurchasePrice, maxPurchasePrice, excludeInCatalogLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a purchase param
     * @param {string} purchaseParamLogicId purchaseParam logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getPurchaseParam = function (purchaseParamLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getPurchaseParam(purchaseParamLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged purchase params filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {string} [type] type of the purhcase param
     * @param {string} [hurlId] hurlId of the purhcase param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getPurchaseParams = function (page, size, includeMetadata, sort, type, hurlId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getPurchaseParams(page, size, includeMetadata, sort, type, hurlId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the single status
     * @summary Get the single status
     * @param {string} statusLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getStatus = function (statusLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getStatus(statusLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of status for a project
     * @param {string} jakProject
     * @param {string} jakTenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getStatusList = function (jakProject, jakTenant, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getStatusList(jakProject, jakTenant, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of status routes for a status
     * @param {string} statusLogicId
     * @param {string} jakProject
     * @param {string} jakTenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getStatusRouteForStatusList = function (statusLogicId, jakProject, jakTenant, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getStatusRouteForStatusList(statusLogicId, jakProject, jakTenant, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a supplier
     * @param {string} supplierLogicId supplier logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getSupplier = function (supplierLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getSupplier(supplierLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged suppliers filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {string} [name] supplier name (LIKE mode)
     * @param {string} [partnerLogicId] filter by exact partner logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getSuppliers = function (page, size, includeMetadata, sort, name, partnerLogicId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getSuppliers(page, size, includeMetadata, sort, name, partnerLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a wallet configuration:  The Backoffice return a wallet configuration by specific id
     * @param {string} idLogic id configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getWalletConfById = function (idLogic, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getWalletConfById(idLogic, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post a new category:  The Backoffice create a new category
     * @param {CreateClusterCategoryRequest} createClusterCategoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.insertCategory = function (createClusterCategoryRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).insertCategory(createClusterCategoryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post a new cluster for a specific category:  The Backoffice create a new cluster
     * @param {string} logicIdCategory category logic id
     * @param {CreateClusterRequest} createClusterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.insertCluster = function (logicIdCategory, createClusterRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).insertCluster(logicIdCategory, createClusterRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Insert Status routes for a status
     * @param {string} jakProject
     * @param {string} jakTenant
     * @param {StatusesRouteListForStatusDto} statusesRouteListForStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.insertStatusRouteForStatus = function (jakProject, jakTenant, statusesRouteListForStatusDto, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).insertStatusRouteForStatus(jakProject, jakTenant, statusesRouteListForStatusDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post a new wallet configuration:  The Backoffice create a new wallet configuration
     * @param {WalletConfigurationRequest} walletConfigurationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.insertWalletConf = function (walletConfigurationRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).insertWalletConf(walletConfigurationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary modify status for a specific idCategory
     * @param {string} logicId category logic id
     * @param {UpdateClusterCategoryStatusRequestChildDto} updateClusterCategoryStatusRequestChildDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.patchStatusCategoryById = function (logicId, updateClusterCategoryStatusRequestChildDto, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).patchStatusCategoryById(logicId, updateClusterCategoryStatusRequestChildDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of all attributes available on JNext Platform, the list of attributes configured for a project, the list of attribute related with the cluster, and the list of cms related to the attribute
     * @summary Get all the attributes
     * @param {string} redemptionsRestartWorkflowId redemptions restart workflow id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.queryRedemptionsRestartWorkflow = function (redemptionsRestartWorkflowId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).queryRedemptionsRestartWorkflow(redemptionsRestartWorkflowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Redeem a reward
     * @param {string} rewardLogicId
     * @param {RedeemRewardRequest} redeemRewardRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.redeemReward = function (rewardLogicId, redeemRewardRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).redeemReward(rewardLogicId, redeemRewardRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Restart a set of redemptions
     * @param {string} jakProject
     * @param {RestartRedemptionsRequest} restartRedemptionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.restartRedemptionWorkflows = function (jakProject, restartRedemptionsRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).restartRedemptionWorkflows(jakProject, restartRedemptionsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page requested page number
     * @param {number} size requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [walletLogicId]
     * @param {Array<string>} [initiativeLogicId]
     * @param {string} [transactionDateStart]
     * @param {string} [transactionDateEnd]
     * @param {number} [minAmount]
     * @param {number} [maxAmount]
     * @param {Array<string>} [statusExternalIds]
     * @param {Array<string>} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.searchTransaction = function (page, size, includeMetadata, walletLogicId, initiativeLogicId, transactionDateStart, transactionDateEnd, minAmount, maxAmount, statusExternalIds, userId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).searchTransaction(page, size, includeMetadata, walletLogicId, initiativeLogicId, transactionDateStart, transactionDateEnd, minAmount, maxAmount, statusExternalIds, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a Attribute
     * @param {string} attributeLogicId Attribute logic id
     * @param {UpdateAttributeRequest} [updateAttributeRequest] Update Attribute request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateAttribute = function (attributeLogicId, updateAttributeRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateAttribute(attributeLogicId, updateAttributeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a brand
     * @param {string} brandLogicId brand logic id
     * @param {UpdateBrandRequest} [updateBrandRequest] Update brand request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateBrand = function (brandLogicId, updateBrandRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateBrand(brandLogicId, updateBrandRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a brand category
     * @param {string} brandCategoryLogicId brand category logic id
     * @param {UpdateBrandCategoryRequest} [updateBrandCategoryRequest] Update brand category request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateBrandCategory = function (brandCategoryLogicId, updateBrandCategoryRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateBrandCategory(brandCategoryLogicId, updateBrandCategoryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update catalogGroupOProduct\'s properties
     * @param {string} catalogGroupLogicId
     * @param {string} catalogProductLogicId
     * @param {UpdateCatalogGroupProductRequest} [updateCatalogGroupProductRequest] Update catalog-group-product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateCatalogGroupProduct = function (catalogGroupLogicId, catalogProductLogicId, updateCatalogGroupProductRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateCatalogGroupProduct(catalogGroupLogicId, catalogProductLogicId, updateCatalogGroupProductRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Modify a category for idCategory
     * @param {string} logicId category logic id
     * @param {UpdateClusterCategoryRequest} updateClusterCategoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateCategoryById = function (logicId, updateClusterCategoryRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateCategoryById(logicId, updateClusterCategoryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an existing cluster:  The Backoffice modify an existing cluster
     * @param {string} logicId cluster logic id
     * @param {UpdateClusterRequest} updateClusterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateClusterById = function (logicId, updateClusterRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateClusterById(logicId, updateClusterRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a liquidation
     * @param {string} liquidationLogicId liquidation logic id
     * @param {LiquidationDto} [liquidationDto] Update liquidation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateLiquidation = function (liquidationLogicId, liquidationDto, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateLiquidation(liquidationLogicId, liquidationDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a partner
     * @param {string} partnerLogicId partner logic id
     * @param {UpdatePartnerRequest} [updatePartnerRequest] Update partner request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updatePartner = function (partnerLogicId, updatePartnerRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updatePartner(partnerLogicId, updatePartnerRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a product
     * @param {string} productLogicId product logic id
     * @param {UpdateProductRequest} [updateProductRequest] Update product request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateProduct = function (productLogicId, updateProductRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateProduct(productLogicId, updateProductRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Product Fee
     * @param {string} catalogProductLogicId
     * @param {UpdateProductFeesRequest} [updateProductFeesRequest] Update product fees request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateProductFees = function (catalogProductLogicId, updateProductFeesRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateProductFees(catalogProductLogicId, updateProductFeesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update product purchase parameter
     * @param {string} productLogicId product logic id
     * @param {UpdateProductPurchaseParamRequest} [updateProductPurchaseParamRequest] Associate purchase param request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateProductPurchaseParameter = function (productLogicId, updateProductPurchaseParamRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateProductPurchaseParameter(productLogicId, updateProductPurchaseParamRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a purchase param
     * @param {string} purchaseParamLogicId purchaseParam logic id
     * @param {UpdatePurchaseParamRequest} [updatePurchaseParamRequest] Update purchaseParam request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updatePurchaseParam = function (purchaseParamLogicId, updatePurchaseParamRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updatePurchaseParam(purchaseParamLogicId, updatePurchaseParamRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a supplier
     * @param {string} supplierLogicId supplier logic id
     * @param {UpdateSupplierRequest} [updateSupplierRequest] Update supplier request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateSupplier = function (supplierLogicId, updateSupplierRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateSupplier(supplierLogicId, updateSupplierRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Modify a wallet configuration for idWalletConfiguration
     * @param {string} idLogic id configuration
     * @param {WalletConfigurationRequest} walletConfigurationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateWalletConfById = function (idLogic, walletConfigurationRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateWalletConfById(idLogic, walletConfigurationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upsert Attribute in a specific flow
     * @param {string} jakProject
     * @param {UpsertAttributeCfgRequestDto} upsertAttributeCfgRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.upsertAttribute = function (jakProject, upsertAttributeCfgRequestDto, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).upsertAttribute(jakProject, upsertAttributeCfgRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post a new flow for a specific cluster:  The Backoffice create or update a new cluster flow
     * @param {string} clusterLogicId cluster logic id
     * @param {string} jakProject
     * @param {UpsertClusterFlowRequestDto} upsertClusterFlowRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.upsertClusterFlow = function (clusterLogicId, jakProject, upsertClusterFlowRequestDto, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).upsertClusterFlow(clusterLogicId, jakProject, upsertClusterFlowRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upsert Status with StatusRoute
     * @param {string} jakProject
     * @param {string} jakTenant
     * @param {StatusesListForProjectDto} statusesListForProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.upsertStatus = function (jakProject, jakTenant, statusesListForProjectDto, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).upsertStatus(jakProject, jakTenant, statusesListForProjectDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminApi;
}(base_1.BaseAPI));
exports.AdminApi = AdminApi;
